import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.jsx";
import PartyFormation from '../../components/Suikoden/TacticsGrid.jsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEO title="Suikoden Tactics any%" mdxType="SEO" />
    <h3 {...{
      "id": "starting-stat-manipulation"
    }}>{`Starting Stat Manipulation`}</h3>
    <p>{`This game has a very easy way to manipulate starting stats for all your characters.`}<br parentName="p"></br>{`
`}{`Simply reset the console, and hit New Game to get seed 0. Back out, and hit new game again to get seed 1, etc.`}<br parentName="p"></br>{`
`}{`Load game works as well.`}</p>
    <p>{`We are going to use Seed 15, RNG 0x71798ad5 post calculation. `}</p>
    <p><strong parentName="p">{`To do this, press New Game / Load Game and back out 15 times. Then press New Game, pick your settings, and start the run.`}</strong></p>
    <p>{`To confirm correct seed:`}</p>
    <ul>
      <li parentName="ul">{`Lazlo HP: 21`}</li>
      <li parentName="ul">{`Snowe HP: 22`}</li>
    </ul>
    <h3 {...{
      "id": "intro-battle"
    }}>{`Intro Battle`}</h3>
    <p>{`Say no to tutorial`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 1 Forward (east)`}</li>
      <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: 1 Down 1 Forward`}</li>
      <li parentName="ul"><strong parentName="li">{`Lazlo`}</strong>{`: 1 Down, attack`}</li>
      <li parentName="ul"><strong parentName="li">{`Snowe`}</strong>{`: 1 Forward, attack`}</li>
    </ul>
    <h3 {...{
      "id": "intro-battle-2"
    }}>{`Intro Battle 2`}</h3>
    <blockquote>
      <p parentName="blockquote">{`Really don't want Kyril to level, Battle at Sea gets way tighter.`}</p>
    </blockquote>
    <p>{`Too much variance for set strat. Kill Elemental ASAP, move units towards right. Kyril can bait by moving forward and placing Flame Force Bead on self. Kill left once they get closer.`}</p>
    <h2 {...{
      "id": "a-chance-encounter-at-sea"
    }}>{`A Chance Encounter at Sea`}</h2>
    <h3 {...{
      "id": "caravan"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "skills"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Andarc: Lightning Magic - D, Godspeed`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "middleport"
    }}>{`Middleport`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-try-on"
      }}>{`Outfitter (Try On)`}</h5>
      <ul>
        <li parentName="ul">{`Seneca: Wind, Water, Flame`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith"
      }}>{`Blacksmith`}</h5>
      <ul>
        <li parentName="ul">{`Andarc: 2`}</li>
        <li parentName="ul">{`Seneca: 2`}</li>
        <li parentName="ul">{`Kyril: 2`}</li>
      </ul>
      <h5 {...{
        "id": "rune-master"
      }}>{`Rune Master`}</h5>
      <ul>
        <li parentName="ul">{`Buy Sword of Thunder`}</li>
        <li parentName="ul">{`Attach Sword of Thunder to Kyril`}</li>
      </ul>
    </Menu>
    <p>{`Gossip > Read all`}<br parentName="p"></br>{`
`}{`Depart`}</p>
    <h3 {...{
      "id": "battle-at-sea"
    }}>{`Battle At Sea`}</h3>
    <h4 {...{
      "id": "setup"
    }}>{`Setup`}</h4>
    <p>{`Swap Kyril and Walter`}</p>
    <PartyFormation formation={[{
      name: 'Hervey',
      x: 0,
      y: 0
    }, {
      name: 'Walter',
      x: 1,
      y: 1
    }, {
      name: 'Andarc',
      x: 2,
      y: 2
    }, {
      name: 'Seneca',
      x: 1,
      y: 3
    }, {
      name: 'Kyril',
      x: 0,
      y: 4
    }]} mdxType="PartyFormation" />
    <h5 {...{
      "id": "beads"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Seneca: Water, Flame`}</li>
      <li parentName="ul">{`Kyril: Lightning`}</li>
    </ul>
    <h4 {...{
      "id": "strategy"
    }}>{`Strategy`}</h4>
    <p>{`Say no to Tutorial`}<br parentName="p"></br>{`
`}{`If Sigurd before Hervey after Standby, retry.`}</p>
    <h5 {...{
      "id": "turn-1"
    }}>{`Turn 1`}</h5>
    <hr></hr>
    <ul>
      <li parentName="ul"><em parentName="li">{`If Blue Mercenary `}<strong parentName="em">{`AFTER`}</strong>{` Seneca`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Hervey`}</strong>{`: 2 Right 4 Up, Standby face up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Walter`}</strong>{`: 5 Up, kill Pirate`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 5 Up, Water Bead 1 Right so it's on her and Hervey. `}<strong parentName="li">{`FACE DOWN`}</strong>{`.`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><em parentName="li">{`If Blue Mercenary `}<strong parentName="em">{`BEFORE`}</strong>{` Seneca`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Hervey`}</strong>{`: 1 Right 5 Up, Standby face right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Walter`}</strong>{`: Move Behind Hervey, Face Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 2 Behind Hervey, Flame Bead Hervey`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Right 1 Up, Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 1 Right 5 Up, Lightning Bead 3 Right (2 Right of box)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Hervey`}</strong>{`: 1 Up 3 Right, face left`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Up 1 Right, Thunder Runner Sigurd`}</li>
    </ul>
    <p>{`Enter Nest of Pirates`}</p>
    <h3 {...{
      "id": "the-night-sea-1"
    }}>{`The Night Sea #1`}</h3>
    <h5 {...{
      "id": "turn-1-1"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Say no to Tutorial`}</li>
      <li parentName="ul"><strong parentName="li">{`Brandeau / Edgar`}</strong>{`: Move below front Pirate, attack & hopefully kill.`}</li>
      <li parentName="ul"><strong parentName="li">{`Brandeau / Edgar`}</strong>{`: Move to closest tile to cannon possible.`}</li>
      <li parentName="ul"><em parentName="li">{`If 1st failed to kill, move 2 Left 1 Up of 1st person, face forward.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-1"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Step on tile to win.`}</li>
    </ul>
    <h3 {...{
      "id": "the-night-sea-2"
    }}>{`The Night Sea #2`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If you finish kill all other Pirates before Kyril's 3rd turn (Fish Spawn), the battle ends.`}<br parentName="p"></br>{`
`}{`Want Andarc LVL2 preferably, so he is slower than Pirates. That way he can Thunder Runner a Pirate.`}<br parentName="p"></br>{`
`}{`Probably want Kyril level 1, just so you have more time.`}</p>
    </blockquote>
    <h4 {...{
      "id": "setup-1"
    }}>{`Setup`}</h4>
    <h4 {...{
      "id": "strategy-1"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-2"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Brandeau`}</strong>{`: 1 Down 5 Right, Kill bottom Pirate (Spear). Face Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Edgar`}</strong>{`: 1 Down 5 Right, Kill bottom Pirate (Spear). Face `}<strong parentName="li">{`Left`}</strong>{`.`}</li>
      <li parentName="ul"><em parentName="li">{`Don't know how fight plays out if they miss a kill. Maybe retry?`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 3 Right 2 Up, Thunder Runner a Pirate. Face away from enemies.`}</li>
      <li parentName="ul"><em parentName="li">{`Usually if an enemy has a turn left and there's a Pirate near Edgar aim for that one. Next Pirate will move onto Lightning Tile and Jolly + Rowdy probably kill.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-2"
    }}>{`Turn 2`}</h5>
    <blockquote>
      <p parentName="blockquote">{`If Jolly or Rowdy got hit twice, you want to Medicine them with Edgar. If Edgar got stunned, can do it with Brandeau instead. BUT ONLY if Jolly + Rowdy will kill an enemy Pirate.`}<br parentName="p"></br>{`
`}{`Want to aim for the Pirates closer to Steele, the ones closer to you are more likely to target Andarc & Peck. But keep in mind Brandeau's range for his 3rd turn.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Brandeau`}</strong>{`: Move behind Pirate that placed Water Tiles and kill him.`}</li>
      <li parentName="ul"><strong parentName="li">{`Edgar`}</strong>{`: Kill a Pirate closer to Steele / Medicine `}<strong parentName="li">{`WITHOUT MOVING`}</strong>{` ally if viable. If no movement he gets a 3rd turn.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Kill last Pirate.`}</li>
    </ul>
    <h4 {...{
      "id": "rewards"
    }}>{`Rewards`}</h4>
    <p>{`S: Steele's Shield (can be useful for 1 fight tops)`}<br parentName="p"></br>{`
`}{`Pirates Survive: Strength Sash (nice but really hard to get)`}<br parentName="p"></br>{`
`}{`Prime Gold Ore if you kill Steele.`}</p>
    <h3 {...{
      "id": "post-battle"
    }}>{`Post Battle`}</h3>
    <p>{`There's a potentially decent bathroom break here during book scene.`}</p>
    <h3 {...{
      "id": "caravan-1"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Recommended, Killer Ring, Str. Sash, all possible medals`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skill"
      }}>{`Learn Skill`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Battlelust - D, Godspeed, equip over Counterattack`}</li>
        <li parentName="ul">{`Andarc: Extra Move`}</li>
      </ul>
    </Menu>
    <p>{`Enter Razril`}</p>
    <h3 {...{
      "id": "razril"
    }}>{`Razril`}</h3>
    <p>{`Go `}<em parentName="p">{`To the Backstreets`}</em>{`.`}</p>
    <h3 {...{
      "id": "bonbon-cleanup"
    }}>{`BonBon Cleanup`}</h3>
    <p>{`Need to S-Rank this. Need at least 5 +tiles.`}</p>
    <h4 {...{
      "id": "strategy-2"
    }}>{`Strategy`}</h4>
    <p>{`Kill BonBons on left, then right.`}<br parentName="p"></br>{`
`}{`Use Thunder Runner + level ups to one shot.`}<br parentName="p"></br>{`
`}{`Kyril takes care of rest.`}<br parentName="p"></br>{`
`}{`Take Advantage of elements as much as possible.`}</p>
    <h4 {...{
      "id": "information"
    }}>{`Information`}</h4>
    <p>{`Left side - Wind Wind Water BonBons, Lightning Elemental`}<br parentName="p"></br>{`
`}{`Right side - Fire Elemental`}</p>
    <p>{`After killing 3 enemies`}<br parentName="p"></br>{`
`}{`Right side - Water Wind Fire`}</p>
    <p>{`Chest - Guard Robe`}</p>
    <h3 {...{
      "id": "reward"
    }}>{`Reward`}</h3>
    <p>{`S: Razril Knight Token`}</p>
    <h3 {...{
      "id": "information-1"
    }}>{`Information`}</h3>
    <p>{`3 more spawn when we kill 3 enemies.`}<br parentName="p"></br>{`
`}{`Treasure Chest is Guard Robe, don't need it to S Rank.`}</p>
    <h3 {...{
      "id": "razril-1"
    }}>{`Razril`}</h3>
    <p>{`Enter Caravan`}</p>
    <h3 {...{
      "id": "caravan-2"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Razril Knight Token`}</li>
      </ul>
      <h5 {...{
        "id": "skills-1"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Seneca: Battle Lust - D, Extra Move`}</li>
      </ul>
    </Menu>
    <p>{`Depart, go to Middleport`}</p>
    <h2 {...{
      "id": "what-lies-beneath-the-surface"
    }}>{`What Lies Beneath the Surface`}</h2>
    <h3 {...{
      "id": "middleport-1"
    }}>{`Middleport`}</h3>
    <p>{`Secret Underground Path`}</p>
    <h3 {...{
      "id": "middleport-secret-underground-path"
    }}>{`Middleport Secret Underground Path`}</h3>
    <h4 {...{
      "id": "setup-2"
    }}>{`Setup`}</h4>
    <p>{`Swap Andarc to tile 1R1U, then swap Andarc with Kyril`}</p>
    <PartyFormation formation={[{
      name: 'Andarc',
      x: 1,
      y: 0
    }, {
      name: 'Seneca',
      x: 0,
      y: 1
    }, {
      name: 'Kyril',
      x: 1,
      y: 2
    }, {
      name: null,
      x: 1,
      y: 3
    }]} mdxType="PartyFormation" />
    <h4 {...{
      "id": "information-2"
    }}>{`Information`}</h4>
    <h5 {...{
      "id": "enemies"
    }}>{`Enemies`}</h5>
    <p>{`Start: 2 Bats Wind 2 Golems & Elemental & Earth`}<br parentName="p"></br>{`
`}{`Left Corner: 2 Bats Earth, Earth Elemental`}<br parentName="p"></br>{`
`}{`End: 2 Bats Wind, 1 Wind Golem 1 Earth Golem`}</p>
    <p>{`2nd Spawn Right Side: 2 Ogres Fire`}<br parentName="p"></br>{`
`}{`2nd Spawn Left Side: 2 Bats Water, 1 Ogre Fire`}<br parentName="p"></br>{`
`}{`First 2 Ogres wont step on Wind Tiles unless someone is in range`}</p>
    <h5 {...{
      "id": "treasure"
    }}>{`Treasure`}</h5>
    <p>{`Top left chest Water Orb`}<br parentName="p"></br>{`
`}{`Bottom Right Chest Leather Armor`}</p>
    <h4 {...{
      "id": "strategy-3"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-3"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Andarc 2 Right, Thunder Runner something if possible.`}</li>
      <li parentName="ul">{`Kyril kill a bird if possible.`}</li>
      <li parentName="ul">{`Seneca either attack bird or talk to Andarc. Want to end up on tile left of Andarc.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-3"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`Kyril clean up birds and/or head right`}</li>
      <li parentName="ul">{`Andarc & Seneca goal is to Cohort the 2 birds on the upper left.`}</li>
      <li parentName="ul">{`Get party to the upper rock and break it. Formation should be:`}</li>
    </ul>
    <PartyFormation formation={[{
      name: 'Rock',
      x: 0,
      y: 0
    }, {
      name: 'Rock',
      x: 1,
      y: 0
    }, {
      name: 'Andarc',
      x: 0,
      y: 1
    }, {
      name: 'Kyril',
      x: 1,
      y: 1
    }, {
      name: 'Seneca',
      x: 0,
      y: 2
    }]} mdxType="PartyFormation" />
    <blockquote>
      <p parentName="blockquote">{`Might want to try to keep Andarc and Seneca alive here to speed up Dying Wish learning time?`}<br parentName="p"></br>{`
`}{`Had to wait 2-3 turns in next battle.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul">{`Once all 3 have their turns together:`}<ul parentName="li">
          <li parentName="ul">{`Andarc & Seneca go Top Left, face away to bait enemies`}<ul parentName="li">
              <li parentName="ul">{`Try to position them so back attacking them doesn't block tiles next to Kyril`}</li>
            </ul></li>
          <li parentName="ul">{`Kyril goes top right.`}</li>
        </ul></li>
      <li parentName="ul">{`Cut through if needed, get Kyril to top right victory tiles.`}</li>
    </ul>
    <h2 {...{
      "id": "the-evil-eye"
    }}>{`The Evil Eye`}</h2>
    <h3 {...{
      "id": "underground-passage-2"
    }}>{`Underground Passage 2`}</h3>
    <h4 {...{
      "id": "setup-3"
    }}>{`Setup`}</h4>
    <h5 {...{
      "id": "beads-1"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Kyril: Flame`}</li>
      <li parentName="ul">{`Seneca: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "information-3"
    }}>{`Information`}</h4>
    <p>{`2 Left Bats Earth Water`}<br parentName="p"></br>{`
`}{`3 Middle Skeletons w/ Sword 2 Wind 1 Lightning`}<br parentName="p"></br>{`
`}{`Right Bat Wind, Right Skeleton w/ Bow Wind, Fire Elemental`}<br parentName="p"></br>{`
`}{`Back Group: Skeleton Sword Fire, 2 Skeleton Bow Fire Lightning`}</p>
    <h4 {...{
      "id": "strategy-4"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-4"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Down 1 Right, Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 1 Down 1 Right, Wind Bead self.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 1 Right 2 Forward, Lightning Force 1 Above Andarc. Face forward.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-4"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Position for optimal Cohort, Thunder Runner enemy that would dodge Cohort (Bow Skeleton on right)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Position for optimal Cohort, Cohort`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on"
    }}>{`Turn 3 & on`}</h5>
    <ul>
      <li parentName="ul">{`Clean up any stragglers. Make sure you don't pass bridge.`}</li>
      <li parentName="ul">{`If you don't have Dying Wish yet, just wait until you do.`}</li>
      <li parentName="ul">{`Also heal Kyril, want him near full HP for next phase.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Needs to end up on top right of bridge.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Needs to end up about 3 behind Kyril. He needs to be able to move to the tile 1 right of Kyril.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Needs to end up about 4 behind 1 left of Kyril. She needs to be able to move to the tile 1 left of Kyril.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-1-phase-2"
    }}>{`Turn 1 Phase 2`}</h5>
    <ul>
      <li parentName="ul">{`Start once your group has all 3 turns next. And all setup is done.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 3 Forward, Flame Force Bead under self. `}<strong parentName="li">{`Face Back`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Standby.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-phase-2"
    }}>{`Turn 2 Phase 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Move to top left of bridge.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Move to tile right of top right of bridge.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 2 back, Dying Wish`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-phase-2"
    }}>{`Turn 3 Phase 2`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Want to get everyone's turn in here for Unite recharges.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca & Andarc`}</strong>{`: Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Kill last Skeleton`}</li>
    </ul>
    <h4 {...{
      "id": "other-info"
    }}>{`Other Info`}</h4>
    <p>{`Left Chest: Flame Force Bead x3`}<br parentName="p"></br>{`
`}{`Top Chest: Salad x5`}<br parentName="p"></br>{`
`}{`Getting either chest spawns a skeleton`}<br parentName="p"></br>{`
`}{`One Skele drops Chain Mail.`}<br parentName="p"></br>{`
`}{`You can use Extra Move to hit hit skele and move back out of trigger. Only hit skeleton will move.`}<br parentName="p"></br>{`
`}{`Soloing with Kyril is actually viable here, don't know if faster though.`}<br parentName="p"></br>{`
`}{`Medicine heals Skeletons :(`}</p>
    <p>{`Want to equip the Chain Mail to Kyril at some point, even if just to sell for more money.`}</p>
    <h3 {...{
      "id": "after-battle"
    }}>{`After Battle`}</h3>
    <p>{`After dungeon re-enter Middleport > Secret Underground Passage`}<br parentName="p"></br>{`
`}{`Depart after cutscenes.`}</p>
    <h2 {...{
      "id": "the-nest-of-pirates"
    }}>{`The Nest of Pirates`}</h2>
    <h3 {...{
      "id": "nest-of-pirates"
    }}>{`Nest of Pirates`}</h3>
    <h4 {...{
      "id": "setup-4"
    }}>{`Setup`}</h4>
    <p>{`Swap Kyril & Seneca`}</p>
    <PartyFormation formation={[{
      name: 'Dario',
      x: 0,
      y: 0
    }, {
      name: 'Seneca',
      x: 0,
      y: 2
    }, {
      name: 'Andarc',
      x: 1,
      y: 2
    }, {
      name: 'Kyril',
      x: 0,
      y: 3
    }]} mdxType="PartyFormation" />
    <h4 {...{
      "id": "beads-2"
    }}>{`Beads`}</h4>
    <ul>
      <li parentName="ul">{`Seneca: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-5"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-5"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 2 Right 1 Down, talk to Nalleo. (Seems to manip good Elemental Position).`}</li>
      <li parentName="ul"><strong parentName="li">{`Nalleo`}</strong>{`: Kill Elemental / Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 2 Left 3 Forward, Standby face forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 2 Left 3 Forward, Lightning Force 1 Right 3 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 6 Forward, Standby face forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Dario`}</strong>{`: 1 Left 2 Forward, Standby face forward.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-5"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><em parentName="li">{`Left Side is just improve and kill slowly and safely.`}</em></li>
      <li parentName="ul"><em parentName="li">{`Strats can adjust based on elemental movements, prioritize killing those.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Seneca, Kyril`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Dario`}</strong>{`: Can heal Kyril if needed.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Cohort, Extra Move forward.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If setup worked properly, should have hit 4. Won't always though, depends on enemy AI.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Right side: Standby until Cohort, should kill at least 3 melees. Move forward and kill stragglers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Left side: Slowly move forward placing wind tiles and killing enemies.`}</p>
        <blockquote parentName="li">
          <p parentName="blockquote">{`Try to count turns until Cohort recharge, will be using it again.`}</p>
        </blockquote>
      </li>
    </ul>
    <h5 {...{
      "id": "turn-4--on"
    }}>{`Turn 4 & on`}</h5>
    <p>{`Place Wind & Lightning Beads under future unit spawns. `}<strong parentName="p">{`WANT WIND FIRST!`}</strong><br parentName="p"></br>{`
`}{`Kill elementals, get into position.`}</p>
    <h4 {...{
      "id": "information-4"
    }}>{`Information`}</h4>
    <h5 {...{
      "id": "enemies-1"
    }}>{`Enemies`}</h5>
    <p>{`2 Front Spearman Water, Swordsman Fire`}<br parentName="p"></br>{`
`}{`Bowman Earth, Staff Lightning`}<br parentName="p"></br>{`
`}{`Left Side Swordsman Fire Spearman Water Bow Earth Roget Wind`}</p>
    <p>{`Last 3 Units spawn when you hit Roget.`}<br parentName="p"></br>{`
`}{`Front Spearman Water, Top Right Bowman Earth, Top Left Swordsman Fire`}</p>
    <p>{`Even if you kill Roget with final blow the pirates still get summoned`}<br parentName="p"></br>{`
`}{`Need to kill all elementals`}</p>
    <h5 {...{
      "id": "rewards-1"
    }}>{`Rewards`}</h5>
    <p>{`S: Edgar's Cape (really good but impossible(?) to get.)`}<br parentName="p"></br>{`
`}{`Chest is Iron Mail`}</p>
    <h2 {...{
      "id": "obel-palace"
    }}>{`Obel Palace`}</h2>
    <p>{`Move to Obel`}</p>
    <h2 {...{
      "id": "the-ruins-of-war"
    }}>{`The Ruins of War`}</h2>
    <p>{`C Skills unlock before next fight.`}</p>
    <h3 {...{
      "id": "obel"
    }}>{`Obel`}</h3>
    <p>{`Depart, go to Middleport`}</p>
    <h3 {...{
      "id": "middleport-2"
    }}>{`Middleport`}</h3>
    <h4 {...{
      "id": "gossip"
    }}>{`Gossip`}</h4>
    <p>{`4th Gossip to recruit Pablo`}</p>
    <h3 {...{
      "id": "caravan-3"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Recommended Equipment, Medals`}</li>
        <li parentName="ul">{`Seneca: Recommended Equipment, Medals`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skill-1"
      }}>{`Learn Skill`}</h5>
      <ul>
        <li parentName="ul">{`Andarc: Extra Move, Lightning - C`}</li>
        <li parentName="ul">{`Kyril: Battle Lust - C`}</li>
        <li parentName="ul">{`Seneca: Batle Lust - C`}</li>
        <li parentName="ul">{`Kika: Battle Lust - C, Extra Move (replace Parry)`}</li>
        <li parentName="ul">{`Flare: Battle Lust - C`}</li>
      </ul>
    </Menu>
    <p>{`Go to Illuya (R1 x4)`}</p>
    <h3 {...{
      "id": "illuya"
    }}>{`Illuya`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-sell"
      }}>{`Outfitter (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Iron Mail, Killer Ring, Medals`}</li>
        <li parentName="ul">{`Seneca: Chain Mail, Medals`}</li>
      </ul>
      <p>{`From now on, Beads will be total count owned.`}</p>
      <h5 {...{
        "id": "outfitter-try-on-1"
      }}>{`Outfitter (Try On)`}</h5>
      <ul>
        <li parentName="ul">{`Seneca: Thunder God Garb. Wind x2, Earth, Flame`}</li>
        <li parentName="ul">{`Kika: Flame, Water, Lightning`}</li>
        <li parentName="ul">{`Flare: Water, Wind`}</li>
        <li parentName="ul">{`Akaghi: `}<strong parentName="li">{`Water x2`}</strong>{`, Flame`}</li>
        <li parentName="ul">{`Mizuki: Flame, Earth, Water`}</li>
        <li parentName="ul">{`Pablo: Wind`}</li>
        <li parentName="ul">{`Trishtan: Flame, Earth, Wind `}<strong parentName="li">{`x2`}</strong></li>
      </ul>
      <h5 {...{
        "id": "blacksmith-1"
      }}>{`Blacksmith`}</h5>
      <p>{`Sharpen Trishtan, Kyril, Andarc, Seneca, Flare to 3`}</p>
      <h5 {...{
        "id": "rune-shop"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy Gale, Sword of Cyclone`}</li>
        <li parentName="ul">{`Attach Sword of Cyclone to Kyril`}</li>
        <li parentName="ul">{`Attach Sword of Thunder to Seneca`}</li>
        <li parentName="ul">{`Attach Gale to Flare`}</li>
      </ul>
    </Menu>
    <p>{`Depart, go to Na-Nal`}</p>
    <h3 {...{
      "id": "na-nal"
    }}>{`Na-Nal`}</h3>
    <h4 {...{
      "id": "gossip-1"
    }}>{`Gossip`}</h4>
    <p>{`Recruit Eugene.`}</p>
    <p>{`Depart, move to El-Eal`}</p>
    <h3 {...{
      "id": "fort-el-eal"
    }}>{`Fort El Eal`}</h3>
    <h4 {...{
      "id": "setup-5"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Kyril',
      x: 0,
      y: 0
    }, {
      name: 'Flare',
      x: 2,
      y: 0
    }, {
      name: 'Trishtan',
      x: 4,
      y: 0
    }, {
      name: 'Andarc',
      x: 1,
      y: 1
    }, {
      name: 'Kika',
      x: 3,
      y: 1
    }, {
      name: 'Seneca',
      x: 2,
      y: 2
    }]} mdxType="PartyFormation" />
    <ol>
      <li parentName="ol">{`Flare Top Left`}</li>
      <li parentName="ol">{`Flare > Kyril`}</li>
      <li parentName="ol">{`Kika Center`}</li>
      <li parentName="ol">{`Kika > Seneca`}</li>
      <li parentName="ol">{`Trishtan Top Right`}</li>
    </ol>
    <h4 {...{
      "id": "beads-3"
    }}>{`Beads`}</h4>
    <ul>
      <li parentName="ul">{`Trishtan: Fire`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-6"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-6"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 1 Left Forward max, place Fire Bead to the right of the archer.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: Forward max and kill the archer.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Forward max`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Forward max.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Left 4 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Forward 4`}</li>
      <li parentName="ul"><em parentName="li">{`Wind Archer and soldier will move onto Fire tiles and attack Flare.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-6"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan, Kika, Seneca, Flare`}</strong>{`: Move forward, kill the 3 Soldiers on Fire tiles. Kika aims Fire, Trishtan back attacks Wind, Flare & Seneca clean up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Move forward max, Thunder Runner Wind Mage.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 1 Left 5 Forward, Swallow Wind Mage to kill.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-1"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Setup for Dying Wish, you want Kyril 1 tile below 1 tile right of the box.`}</li>
      <li parentName="ul"><em parentName="li">{`Experimental: From Kyril's Dying Wish Tile have him Flame Bead 3 Up 1 Right. Helps with Mage AI. Don't hit him till he moves there?`}</em></li>
      <li parentName="ul">{`If units are too far away, just wait for them to come to you. If they moved forward on right side it's fine to attack now. You don't want to attack them near middle because it will pull other enemies towards the right.`}</li>
      <li parentName="ul">{`Have Flare break the chest on the right to get the Wing Mail. It doesn't need to be rushed, you'll have time as you chase the last mage.`}</li>
    </ul>
    <h4 {...{
      "id": "information-5"
    }}>{`Information`}</h4>
    <p>{`Chest is Wing Mail`}</p>
    <blockquote>
      <p parentName="blockquote">{`2 Recruits from Nest of Pirates available now`}</p>
    </blockquote>
    <h4 {...{
      "id": "reward-1"
    }}>{`Reward`}</h4>
    <p>{`S: Figure of an Old Man (useless)`}</p>
    <h3 {...{
      "id": "world-map"
    }}>{`World Map`}</h3>
    <p>{`Move to Ruins of Collanbal`}</p>
    <h3 {...{
      "id": "ruins-of-collanbal"
    }}>{`Ruins of Collanbal`}</h3>
    <h4 {...{
      "id": "setup-6"
    }}>{`Setup`}</h4>
    <h5 {...{
      "id": "equipment-3"
    }}>{`Equipment`}</h5>
    <ul>
      <li parentName="ul">{`Kyril: Wing Mail`}</li>
    </ul>
    <PartyFormation formation={[{
      name: 'Kika',
      x: 0,
      y: 0
    }, {
      name: 'Andarc',
      x: 0,
      y: 1
    }, {
      name: 'Seneca',
      x: 0,
      y: 2
    }, {
      name: 'Flare',
      x: 0,
      y: 3
    }, {
      name: 'Pablo',
      x: 1,
      y: 1
    }, {
      name: 'Trishtan',
      x: 1,
      y: 2
    }, {
      name: 'Kyril',
      x: 1,
      y: 3
    }]} mdxType="PartyFormation" />
    <h5 {...{
      "id": "beads-4"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Trishtan: Earth`}</li>
      <li parentName="ul">{`Kika: Lightning`}</li>
      <li parentName="ul">{`Pablo: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-7"
    }}>{`Strategy`}</h4>
    <p>{`Anyone not mentioned just improvise, goal of killing lower half of soldiers.`}</p>
    <h5 {...{
      "id": "turn-1-7"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 4 Forward 1 Down, place Earth Force Bead between 2 Lightning Bandits.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: 4 Down, attack Bandit in front of her.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Forward max and Lightning Force on her Tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Forward max, Falcon Slash / Attack Bandit.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Forward max, Thunder Runner other Lightning Bandit`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Down max, attack and hopefully kill a Bandit`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: 1 Up Forward 3, Wind Bead 1 Down 2 Forward (Between Bandit and Andarc)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-7"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Go behind Earth Bandit and kill him.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Down 4 (2 right of rock), Lightning Force Bead where Seneca will stand for Cohort (4L)`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Forward 4 Down 1, Lightning Force between 3 back bandits`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Forward 4 Down 1, Cohort with Seneca back 3 Bandits`}</li>
      <li parentName="ul">{`Kyril & Flare kill other side, Pablo chills.`}</li>
    </ul>
    <h4 {...{
      "id": "rewards-2"
    }}>{`Rewards`}</h4>
    <p>{`S: Fancy Necklace`}</p>
    <h4 {...{
      "id": "notes"
    }}>{`Notes`}</h4>
    <p>{`Back left Bandits like to run towards your characters and place beads turn 1`}</p>
    <h3 {...{
      "id": "world-map-1"
    }}>{`World Map`}</h3>
    <p>{`Go to Caravan`}</p>
    <h3 {...{
      "id": "caravan-4"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Equip medals to people for selling. Flare & Trishtan are good choices.`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skill-2"
      }}>{`Learn Skill`}</h5>
      <ul>
        <li parentName="ul">{`Trishtan: Godspeed`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "merseto"
    }}>{`Merseto`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-sell-1"
      }}>{`Outfitter (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Flare's Chainmail & Medals`}</li>
        <li parentName="ul">{`Trishtan's Chainmail, Leather Gloves, Medals`}</li>
        <li parentName="ul">{`Pablo's Guard Robe`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Can buy until 15000 left, must have at least 15000 after.`}</p>
      </blockquote>
      <h5 {...{
        "id": "outfitter-buy"
      }}>{`Outfitter (Buy)`}</h5>
      <ul>
        <li parentName="ul">{`Andarc: Tome of the Black Arts`}</li>
        <li parentName="ul"><em parentName="li">{`Kyril: Str. Sash`}</em></li>
        <li parentName="ul">{`Seneca: Str. Sash`}</li>
        <li parentName="ul">{`Flare: Str. Sash`}</li>
        <li parentName="ul">{`Kika: Gauntlets, Str. Sash`}</li>
        <li parentName="ul">{`Trishtan: Wing Mail, Gauntlets, Str. Sash, Fur Cape`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith-15000"
      }}>{`Blacksmith (15000)`}</h5>
      <p>{`Sharpen Kyril, Kika, Seneca, Trishtan, Flare to 4.`}</p>
    </Menu>
    <p>{`Read 3 Gossip and go to Port to continue story.`}</p>
    <h3 {...{
      "id": "merseto-port"
    }}>{`Merseto port`}</h3>
    <h4 {...{
      "id": "setup-7"
    }}>{`Setup`}</h4>
    <p>{`Leave Kika in back slot, remove others.`}</p>
    <h5 {...{
      "id": "beads-5"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Seneca: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "information-6"
    }}>{`Information`}</h4>
    <p>{`Enemies spawn & merchant start moving when you go 2 tiles past bridge.`}<br parentName="p"></br>{`
`}{`Chest is Kangacorn Orb`}</p>
    <h4 {...{
      "id": "strategy-8"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-8"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul">{`Seneca: 2 right 3 down, place Wind Force Bead behind first Pirate`}</li>
      <li parentName="ul">{`Andarc: Move behind Seneca, Thunder Runner non-bow Pirate. Face Forward if Bow Pirate hasn't moved yet, back otherwise.`}</li>
      <li parentName="ul">{`Kyril: Move next to Seneca, Attack Bow Pirate`}</li>
      <li parentName="ul">{`Kika: Move back 1 tile 2 turns, then run.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-8"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul">{`2 Faster units (Kyril & Seneca): Forward 2 tiles, Standby. You don't want to move past first tile after bridge, it triggers more unit spawns.`}</li>
      <li parentName="ul">{`Slower Unit (Andarc): Forward 5 tiles, 2 past bridge. Can Thunder Runner Pirate behind group. Spawn other units.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-2"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Kill Merchant, should die to Thunder Runner + Kyril attack. Seneca can attack or place beads.`}</li>
    </ul>
    <h3 {...{
      "id": "merseto-1"
    }}>{`Merseto`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "rune-shop-1"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 3 Kangacorn`}</li>
        <li parentName="ul">{`Attach Kangacorn to Trishtan`}</li>
      </ul>
    </Menu>
    <p>{`Depart`}</p>
    <h2 {...{
      "id": "an-old-acquaintance"
    }}>{`An Old Acquaintance`}</h2>
    <p>{`Move to El-Eal, enter it.`}</p>
    <h3 {...{
      "id": "el-eal"
    }}>{`El-Eal`}</h3>
    <h4 {...{
      "id": "setup-8"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Seneca',
      x: 0,
      y: 2
    }, {
      name: 'Flare',
      x: 1,
      y: 1
    }, {
      name: 'Andarc',
      x: 1,
      y: 3
    }, {
      name: 'Kyril',
      x: 2,
      y: 0
    }, {
      name: 'Trishtan',
      x: 2,
      y: 2
    }, {
      name: 'Kika',
      x: 2,
      y: 4
    }]} mdxType="PartyFormation" />
    <ol>
      <li parentName="ol">{`Swap: Trishtan & Kika`}</li>
      <li parentName="ol">{`Mount: Trishtan`}</li>
      <li parentName="ol">{`Swap: Flare & Kika`}</li>
      <li parentName="ol">{`Swap: Flare & Kyril`}</li>
      <li parentName="ol">{`Swap: Flare & Seneca`}</li>
    </ol>
    <h5 {...{
      "id": "beads-6"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Flare: Water`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-9"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-9"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 6 Down 3 Left, Rush Orange Fish from front. `}<strong parentName="li">{`(NOT RED FISH)`}</strong>{` Face down.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 4 Down 1 Left, Attack / Falcon Slash Red Fish. Extra move 1 Down, face left.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: 5 Up, Water Force Bead 1 down 2 right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 2 Left 3 Down, Lightning Force tile below her (towards the fish).`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 2 Left 3 Down, Thunder Runner a fish, trying to avoid allies.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 1 Right Max Up, Attack Bowman if you can.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-9"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Make sure you keep path cleared for Seneca & Andarc to move forward. This is really important!`}</strong></li>
      <li parentName="ul"><em parentName="li">{`Addionally, stay of of Roget's range so he doesn't move.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Kill a fish, preferably Blue Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Kill a fish, move forward towards ramp. Face in a way that they won't block Seneca / Andarc.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Goal is to move 1 Left 4 Down, want to stop on Lightning tile & attack a fish along the way.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Goal is to move next to Seneca (if before her, don't take her tile). Thunder Runner a fish with +tile along the way.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril & Flare`}</strong>{`: Kyril hits stuff, Flare finishes fish. Continue rest of fight.`}</li>
      <li parentName="ul"><em parentName="li">{`Mizuki & Akaghi do nothing the whole fight`}</em>{`.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-3"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Goal is to kill enough enemies to spawn last 2 fish before Andarc's turn for Cohort. Clear path for Seneca if needed`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`Kika & Trishtan`}</strong>{`: Kill fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 2 Down 3 Left, place Lightning tile under self.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 2 Down 3 Left, Cohort.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-and-on"
    }}>{`Turn 4 and on`}</h5>
    <ul>
      <li parentName="ul">{`Kill remaining fish, if Kyril and Flare are slow to kill stuff move Trishtan towards them to help.`}</li>
    </ul>
    <h4 {...{
      "id": "information-7"
    }}>{`Information`}</h4>
    <p>{`If Seneca is faster than Roget he will Wind of Sleep her, which causes pretty big problems if it hits.`}<br parentName="p"></br>{`
`}{`Sadly no place to get a Salad.`}</p>
    <p>{`Chest 1 Iron Mail`}<br parentName="p"></br>{`
`}{`Chest 2 Wind Orb (By Mizuki & Akaghi)`}</p>
    <h3 {...{
      "id": "world-map-2"
    }}>{`World Map`}</h3>
    <p>{`Go to Ruins of Collanbal`}</p>
    <h3 {...{
      "id": "ruins-of-collanbal-1"
    }}>{`Ruins of Collanbal`}</h3>
    <h4 {...{
      "id": "setup-9"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Kyril',
      x: 0,
      y: 0
    }, {
      name: 'Andarc',
      x: 0,
      y: 1
    }, {
      name: 'Seneca',
      x: 1,
      y: 0
    }, {
      name: 'Millay',
      x: 1,
      y: 1
    }, {
      name: 'Akaghi',
      x: 2,
      y: 0
    }, {
      name: 'Trishtan (K)',
      x: 2,
      y: 1
    }, {
      name: null,
      x: 2,
      y: 2
    }]} mdxType="PartyFormation" />
    <ol>
      <li parentName="ol">{`Kyril -> Andarc`}</li>
      <li parentName="ol">{`Switch Flare -> Millay (R1 1D)`}</li>
      <li parentName="ol">{`Trishtan -> Seneca`}</li>
      <li parentName="ol">{`Trishtan -> Pablo`}</li>
      <li parentName="ol">{`Top Right Slot -> `}<strong parentName="li">{`Akaghi`}</strong>{` (R1 1D)`}</li>
      <li parentName="ol">{`Cancel Kika`}</li>
      <li parentName="ol">{`Cancel Pablo`}</li>
    </ol>
    <h5 {...{
      "id": "beads-7"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Mizuki: Water`}</li>
      <li parentName="ul">{`Trishtan: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-10"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-10"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Forward max, `}<strong parentName="li">{`Dismount`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Forward max.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: `}<strong parentName="li">{`Mount`}</strong>{`, 1 Up Forward 8, next to Trishtan. Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Akaghi`}</strong>{`: Up 1 Forward 5.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Forward max, face down.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Forward max.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-10"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Up 1 Forward 5, right above rock. Wind Force Bead 1 down on rock, face towards Martin.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Forward max, Lightning Force 1 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Thunder Runner Martin / Standby if you can cast a spell before his next turn.`}</li>
      <li parentName="ul"><strong parentName="li">{`Akaghi`}</strong>{`: Move forward, place Water Tile under Martin. Don't block Kyril's path for Swallow.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Move behind Martin, switch to Kika. Falcon Slash.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Move up and attack / Swallow.`}</li>
    </ul>
    <p>{`Can also switch to mage / Flare for more damage if needed.`}</p>
    <h4 {...{
      "id": "information-8"
    }}>{`Information`}</h4>
    <p>{`Bottom left units dont move.`}</p>
    <h4 {...{
      "id": "rewards-3"
    }}>{`Rewards`}</h4>
    <p>{`S: Fancy Necklace`}</p>
    <h2 {...{
      "id": "the-laboratory"
    }}>{`The Laboratory`}</h2>
    <h3 {...{
      "id": "world-map-3"
    }}>{`World Map`}</h3>
    <p>{`Move to Merseto`}</p>
    <h3 {...{
      "id": "merseto-2"
    }}>{`Merseto`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-sell-2"
      }}>{`Outfitter (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Everything on Jeremy through Gretchen`}</li>
      </ul>
      <h5 {...{
        "id": "outfitter-try-on-2"
      }}>{`Outfitter (Try On)`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Gauntlets, Fur Cape, Wind x3, Flame, Water `}<em parentName="li">{`Replace Razril Knight Token`}</em></li>
        <li parentName="ul">{`Millay: Wing Mail, Gauntlets, (if no Steele's Shield), Strength Sash, Fur Cape`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith---3000"
      }}>{`Blacksmith - 3000`}</h5>
      <ul>
        <li parentName="ul">{`Millay: LVL4 (Up L1 Down)`}</li>
      </ul>
      <h5 {...{
        "id": "rune-shop---3000"
      }}>{`Rune Shop - 3000`}</h5>
      <ul>
        <li parentName="ul">{`Buy 3 Fire Orbs`}</li>
        <li parentName="ul">{`Buy 2 Sword of Rage`}</li>
        <li parentName="ul">{`Attach Fire to Andarc`}</li>
        <li parentName="ul">{`Attach Hawk to Seneca`}</li>
        <li parentName="ul">{`Attach Sword of Lightning to Flare`}</li>
        <li parentName="ul">{`Attach Kangacorn to Millay`}</li>
        <li parentName="ul">{`Attach Gale to Trishtan`}</li>
      </ul>
    </Menu>
    <p>{`Enter Caravan`}</p>
    <h3 {...{
      "id": "caravan-5"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kika: Razril Knight Token, Medals.`}</li>
        <li parentName="ul">{`Millay: Steele's Shield if you have it, Medals.`}</li>
      </ul>
      <h5 {...{
        "id": "skills-2"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Battlelust - B, Extra Move`}</li>
        <li parentName="ul">{`Andarc: Fire Magic - B`}</li>
        <li parentName="ul">{`Seneca: Battlelust - B, Bull's Eye - B`}</li>
        <li parentName="ul">{`Kika: Battlelust - B`}</li>
        <li parentName="ul">{`Millay: Bull's Eye - B, Extra Move, Godspeed`}</li>
        <li parentName="ul">{`Ameria: Godspeed`}</li>
      </ul>
    </Menu>
    <p>{`Depart to Caleron Laboratory.`}</p>
    <h3 {...{
      "id": "caleron-laboratory-1"
    }}>{`Caleron Laboratory #1`}</h3>
    <h4 {...{
      "id": "setup-10"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Corselia',
      x: 0,
      y: 0
    }, {
      name: 'Trishtan (K)',
      x: 0,
      y: 1
    }, {
      name: 'Millay',
      x: 0,
      y: 2
    }, {
      name: 'Kyril',
      x: 1,
      y: 0
    }, {
      name: 'Andarc',
      x: 1,
      y: 1
    }, {
      name: 'Seneca',
      x: 1,
      y: 2
    }]} mdxType="PartyFormation" />
    <ol>
      <li parentName="ol">{`Switch Ameria -> Millay`}</li>
    </ol>
    <h5 {...{
      "id": "beads-8"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Trishtan: Wind`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-11"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-11"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 5 Up 2 Forward. `}<strong parentName="li">{`Dismount`}</strong>{`. Wind Bead 1 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 3 Up. Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: 1 Down 2 Forward. Breath of Ice 1 Up 2 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Mount, 7 Up 3 Forward. Rush Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Standby.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{` Forward 1, Dying Wish. Extra 2 Back 3 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Finish 3 Fish with Breath of Ice.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-11"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 5 Forward, kill Blue Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Switch to Kika, Falcon Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: If Blue Fish survived kill it. Else 1 Up 2 Forward and kill Kika's fish if it survived and extra move forward. Else just 5 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Kill a Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: 3 Forward, Breath of Ice 3 Fish.`}</li>
      <li parentName="ul">{`Top side: Slowly move forward with Wind tiles and kill everything. Hold choke so fish don't get past you.`}</li>
      <li parentName="ul">{`Don't move past 3 Forward of furthest Wind Tile Kika placed T1. Or, alternatively, the hole above, that's 1 past the bridge at the top. This triggers the other fish to move forward. Only do this when ready.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3--on-1"
    }}>{`Turn 3 & on`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Go next to Seneca, Cohort.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Finish Breath of Ice.`}</li>
      <li parentName="ul"><strong parentName="li">{`Top side`}</strong>{`: Once you clear out enough fish with other group start moving forward. Don't move too far though, or you risk getting Breath of Iced by far back fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Move behind Yellow Fish and Strong Arm to kill.`}</li>
    </ul>
    <h4 {...{
      "id": "information-9"
    }}>{`Information`}</h4>
    <p>{`Positive Terrain requirement is 25, can get with 17.`}<br parentName="p"></br>{`
`}{`Gotta kill elementals`}<br parentName="p"></br>{`
`}{`2 new groups spawn, one in bottom column 1 in middle`}<br parentName="p"></br>{`
`}{`1 co-op for each bottom group is good strat.`}<br parentName="p"></br>{`
`}{`Chest is Ninja Braces`}</p>
    <h4 {...{
      "id": "reward-2"
    }}>{`Reward`}</h4>
    <p>{`S: Rusty Cog (REALLY WANT THIS)`}</p>
    <h3 {...{
      "id": "caleron-laboratory-2"
    }}>{`Caleron Laboratory #2`}</h3>
    <h4 {...{
      "id": "setup-11"
    }}>{`Setup`}</h4>
    <p><strong parentName="p">{`Equip Rusty Cog to Millay`}</strong></p>
    <PartyFormation formation={[{
      name: 'Millay',
      x: 0,
      y: 0
    }, {
      name: 'Trishtan (K)',
      x: 1,
      y: 0
    }, {
      name: 'Seneca',
      x: 2,
      y: 0
    }, {
      name: 'Kyril',
      x: 0,
      y: 1
    }, {
      name: 'Andarc',
      x: 1,
      y: 1
    }, {
      name: 'Corselia',
      x: 2,
      y: 1
    }]} mdxType="PartyFormation" />
    <ol>
      <li parentName="ol">{`Andarc -> Trishtan`}</li>
      <li parentName="ol">{`Equip: Millay - Rusty Cog`}</li>
      <li parentName="ol">{`Millay -> Seneca`}</li>
      <li parentName="ol">{`Seneca -> Kyril`}</li>
    </ol>
    <h4 {...{
      "id": "beads-9"
    }}>{`Beads`}</h4>
    <ul>
      <li parentName="ul">{`Seneca: Fire, Earth`}</li>
      <li parentName="ul">{`Kyril: Fire`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-12"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-12"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 8 Forward 1 Up, Switch to Kika. Falcon Storm Thrust bottom Fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Mount Kangacorn, 1 Up 9 Forward. Rush `}<strong parentName="li">{`BOTTOM`}</strong>{` Fish. Face up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 1 Up 4 Forward, Flame Bead 4 Up. `}<em parentName="li">{`This makes the top right fish go bottom right with rest.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: 2 Forward 1 Up, Breath of Ice 4 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 2 Forward 1 Up, Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 4 Forward, Flame Bead 4 Up.`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/2b616aee1012f0620014fc09d192dbf8/6af66/Caleron2T2Pos.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADQ0lEQVQozw3OS3MTBQAA4L0z3q00YR/d7GY3+37vZrOb3U1C3qkUh1iqTJBKU0KN6YNqIJ0KEwoJqUkHEZy2dJgyxVYLg9bRjjrVUdupBziIB2569EfIL/g+IJs+OTO98MH03ET9SuVSvTR+4Xx1cmruWr3Zbtz4dG5h8UqzNTt/vVq/Wm00yx/Nn59pnKt9PDpZH528DHyzu7+7/+fm052N7Sc7e7//+uzv5fVH3cXuxr3l7dbNr9qtrdbi5t0bS507vVuff7+91e7dWV1/fP/xTu/BfSBiha1wtOiNOKatm7IRMchgsFwbnp8Zu1y+8MnEh7cuFptj5y4Olt5x0rONytnxUnm2evZS4+3RMYCiCSZEpcR0XIqFOUvkZBSFYw6vmjxn6qqpIBiIsRKhu1RIICg5yDIgHkBxuu8YBISNyHE1X1Dzp/WoKUQ5UYrZhCySKIYYGsWFJUQOg5IKKipGMQwWwjEUQWAUDRABArB0lwjhCq/ljBjLsDKj5JxBV0k6Om1qLMSIKMvBWAAegEHQD6MwCPlCBK2SlhaMAm7E9fRYysmLEmNbsZHY0JB+KqeOJOShpFZwLJvAEAwjVNqgGTqAIQg6gGEoE2LwAAbohmQbLkdzNM9wAuMpniNGFd4KkYxmhh3Xznv2iaTnmVHLtV5/o0/k2dn3S7X3RmiaBCAExkgiFKRFSR3AYJTEfWA/RpJkkJRZOxNJZrVCRopTnKhQeJjDT+XSD7sLv337JUURgKTxnpsoHj+TTZ9wo27KfjOh5vOR04XIcNYqOmpaEyI0SQcJnCWJME+IgnC1Wq7Xxo+8dgRIZePJXPpVL5NLDRdKbyXezXknDTmsKBonULIhUwzOCDwyANGifBT0e5nB9vUFnueDFA3YMdNyzXgq7sasTDadTDlOwmF5kpVELBjAQ5QP9Pf1H9Uj9pO9P777+WD34PmP+4df//DTytZToHtvs9npVaaqldpEZWo66kUpjusHfT4I9EMg9ArkhWOQr3imtP/Xf8+fHR68ePnLi38OX/67tbsHXGuttm8vN7u97sr6Zw82ZF3xwyAjShiBKYaBEwFOFCC434knOksPO2t3l1bX2iuPbq9t3Ox88T+7AQ5gv83BuwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "T2 Positions after Seneca's 2nd turn",
            "title": "T2 Positions after Seneca's 2nd turn",
            "src": "/static/2b616aee1012f0620014fc09d192dbf8/6af66/Caleron2T2Pos.png",
            "srcSet": ["/static/2b616aee1012f0620014fc09d192dbf8/8ff5a/Caleron2T2Pos.png 240w", "/static/2b616aee1012f0620014fc09d192dbf8/e85cb/Caleron2T2Pos.png 480w", "/static/2b616aee1012f0620014fc09d192dbf8/6af66/Caleron2T2Pos.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <blockquote>
      <p parentName="blockquote">{`Positions after Seneca's 2nd turn`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-12"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 1 Down 4 Left. Earth Bead 4 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Falcon Thrust Fish. 2 Up 4 Left. `}<em parentName="li">{`Backup for Roget`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 5 Up 3 Left onto right Fire Tile, Face left.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Can Kindness Drops Millay if she's in danger.`}</li>
      <li parentName="ul">{`Others: Can kill Archer, or potentially correct tiles for Roget if Lightning Mage placed Wind Tiles T1.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-4"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Rush Roget, GG`}</li>
    </ul>
    <h4 {...{
      "id": "reward-3"
    }}>{`Reward`}</h4>
    <p>{`S: Rusty Cog`}</p>
    <h2 {...{
      "id": "out-to-get-the-outlaws"
    }}>{`Out to get the Outlaws`}</h2>
    <h3 {...{
      "id": "after-caleron-laboratory"
    }}>{`After Caleron Laboratory`}</h3>
    <p>{`Go to Merseto`}</p>
    <h3 {...{
      "id": "merseto-3"
    }}>{`Merseto`}</h3>
    <p>{`Read Gossip #1`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-try-on-3"
      }}>{`Outfitter (Try On)`}</h5>
      <ul>
        <li parentName="ul">{`Corselia: Tome of Black Arts`}</li>
        <li parentName="ul">{`Seneca: Corset, Wind`}</li>
      </ul>
      <h5 {...{
        "id": "rune-shop-2"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Attach Fire to Corselia`}</li>
        <li parentName="ul">{`Attach Sword of Rage to Kika & Seneca`}</li>
      </ul>
    </Menu>
    <p>{`Go to Caravan.`}</p>
    <h3 {...{
      "id": "caravan-6"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Corselia: Fire Magic - B (equip over Water), Concentration - B, Extra Move, Godspeed`}</li>
        <li parentName="ul">{`Millay: Battle Lust - B`}</li>
        <li parentName="ul">{`Mizuki: Extra Move, Godspeed`}</li>
      </ul>
    </Menu>
    <p>{`Depart, go to Terana Plain`}</p>
    <h3 {...{
      "id": "terana-plain"
    }}>{`Terana Plain`}</h3>
    <h4 {...{
      "id": "setup-12"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Ameria',
      x: 0,
      y: 3
    }, {
      name: 'Gretchen',
      x: 1,
      y: 2
    }, {
      name: 'Corselia',
      x: 2,
      y: 1
    }, {
      name: 'Kyril',
      x: 3,
      y: 0
    }, {
      name: 'Millay (K)',
      x: 1,
      y: 4
    }, {
      name: 'Jeremy',
      x: 2,
      y: 3
    }, {
      name: 'Wendel',
      x: 3,
      y: 2
    }, {
      name: 'Pablo',
      x: 4,
      y: 1
    }]} mdxType="PartyFormation" />
    <blockquote>
      <p parentName="blockquote">{`Andarc is switched in so he goes 2nd at least once.`}<br parentName="p"></br>{`
`}{`This is so Corselia doesn't get all kills and overlevel, so she will level in Haruna.`}</p>
    </blockquote>
    <p>{`Positions don't matter much, want people in certain quadrants.`}<br parentName="p"></br>{`
`}{`Kangacorn riders bottom left quadrant, others top right quadrant.`}</p>
    <h4 {...{
      "id": "strategy-13"
    }}>{`Strategy`}</h4>
    <p><strong parentName="p">{`DON'T EVER STAND ON FIRE TILES!`}</strong></p>
    <h5 {...{
      "id": "turn-1-13"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Go to Wind Elemental's right side (where it was if it moved), `}<strong parentName="li">{`DISMOUNT`}</strong>{`, attack to kill it.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Start casting Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Water Bead Corselia.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kangacorn Riders`}</strong>{`: Mount Kangacorn, go to places to place tiles, switch to Kika / Seneca and Rage Force Bead.`}<ul parentName="li">
          <li parentName="ul">{`You should generally only need 2, the third is a backup. If you still can't cover all enemies, focus on the ones more to the right. You can kill one with Millay as a backup next turn.`}</li>
          <li parentName="ul">{`Can swap to `}<strong parentName="li">{`Ema`}</strong>{` for 3rd bead.`}</li>
        </ul></li>
      <li parentName="ul"><strong parentName="li">{`Wendel`}</strong>{`: Switch to `}<strong parentName="li">{`Andarc`}</strong>{`, Blazing Wall`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Switch to Flare, Lightning Force for Andarc.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-13"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Mages`}</strong>{`: Cast Blazing Wall again.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Mount, Move 2 behind between where Seneca & Kika will be.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca & Kika`}</strong>{`: Move to 1 left/right center of rock, 2 below it's start. For reference, it's 3 up from Kyril's / top right starting tile. Each use Flame Force 2 infront of their position. Center of rock is same column as Mercenary Leader.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Move towards Seneca & Kika, Wind Force to get tile between them.`}<ul parentName="li">
          <li parentName="ul">{`This can maybe be skipped if they face towards middle, to make Leader step on Fire tile. Can also be skipped if the leader went toward's a side, not straight down middle. Actually maybe always make them face middle and Wind Force between them.`}</li>
        </ul></li>
    </ul>
    <h5 {...{
      "id": "turn-3-5"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Millay kill any remaining units, should just be Fire Mage.`}</li>
    </ul>
    <h4 {...{
      "id": "reward-4"
    }}>{`Reward`}</h4>
    <p>{`S: Dried Grass Amulet (HP+30 SKL+5 PDF+5)`}</p>
    <h2 {...{
      "id": "hope-in-haruna"
    }}>{`Hope in Haruna`}</h2>
    <h3 {...{
      "id": "caravan-7"
    }}>{`Caravan`}</h3>
    <h3 {...{
      "id": "haruna"
    }}>{`Haruna`}</h3>
    <h4 {...{
      "id": "setup-13"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Trishtan (K)',
      x: 1,
      y: 0
    }, {
      name: 'Gretchen',
      x: 1,
      y: 1
    }, {
      name: 'Kyril',
      x: 1,
      y: 2
    }, {
      name: 'Andarc',
      x: 1,
      y: 3
    }, {
      name: 'Jeremy',
      x: 0,
      y: 0
    }, {
      name: 'Pablo',
      x: 0,
      y: 1
    }, {
      name: 'Wendel',
      x: 0,
      y: 2
    }, {
      name: 'Ameria',
      x: 0,
      y: 3
    }]} mdxType="PartyFormation" />
    <h5 {...{
      "id": "beads-10"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Kyril: Wind x2`}</li>
      <li parentName="ul">{`Seneca: Wind`}</li>
      <li parentName="ul">{`Kika: Flame, `}<em parentName="li">{`Water: backup`}</em></li>
      <li parentName="ul">{`Flare: Wind`}</li>
      <li parentName="ul">{`Mizuki: Flame, Earth`}</li>
      <li parentName="ul">{`Akaghi: Water, `}<em parentName="li">{`Flame: backup`}</em></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADC0lEQVQozw3QW3OaaACAYX7h7k1vdl3T1TSpkCgKiIJyBkFBPs4gaIxGjYdUG21SO02a6SltZ7s7k5mmM73qbX/G5u69e2ZeyHI64dGoezJLhtPucBb2jr1OkozH4+VqstwM56vh4vno2eZouhzMV73ZKp6cJZPldP1qtb2C3ny52378Z75+MTvfXNx8vPn67XT1fLRpG4Ek0HxDEBssrwiSzAmSpDXt6OJiAYBOV+otvQ1Fnjs+ihIfCPW6zNRVUaRQeNElWXGvVMxWyGyZfNKopAUsVeVQUqs73ZbFotJuyq8fQqClDhNv0A2ZarV0gKBwDtndrRP7fO1Q5mu+RgUyHlqapcuua7gBsBwAVMlVeY2lIdCUR/3kqONpkqiIoibLeD7PkSiBZGgCEQqPQeHPSKF9s+mZOtDkxLfNZoOvVVWRhRSBazcbtmmE3sM6r9/riCyHw9n9QqrYLB7kMwpfiQPDjcN26FMt3U06q+nA1SVPFyEbGL5reY7pO6CXRLapSwxN4sUnCIyWciUSLwsC7YWk7RHAqTiBYPv9bhzqCkfkIc8G0+l4PBp04yiOgnqFYCmyjGHpnexOsUyTxYDY4RWR5Jgax2gipz6gy4TptfkyAgWBPZufDgf9XhzGoWe0mkytVi7kcySCVff5x7+1c78rxD52kMGQTI2l/OPg7bs5mLQYrgrJEhv4bujbw363343ijk9VKoWnMEzBiHn4F5x2JSyWCKpWLTeUmqromvzt+sKuY2U0D1EU3tZboe9EgdsJ3Ch0gWkQKFZC86LJVzlS4BgFz0nYnshUCIbBFVmxRFKmSRKDCAzRVdmx2p5tarLYVOWHYCQGPnxayGbTjx5lUn+Ixb0TBb++/Xr1+f7m7sf52/eXt19G6y1kn66j0SKMwuF40hsMPN9xgaGBRg6Fd5C/8VxagVMuTw4S/+X3X//9e/vp7v7d/c/P338+u/oA8b1FZ7ldrDfn1+/PLl+bwGookufaAsPShorJouFaEUu4cSydXR9fvTx5sT1+9Wly+bp3uvgfhkfM85MEyREAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Turn 1 Setup",
            "title": "Turn 1 Setup",
            "src": "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png",
            "srcSet": ["/static/783a628dbb7f0af3379e07089c087362/8ff5a/HarunaT1Setup.png 240w", "/static/783a628dbb7f0af3379e07089c087362/e85cb/HarunaT1Setup.png 480w", "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "strategy-14"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-14"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 4 Right 4 Down, `}<strong parentName="li">{`DISMOUNT`}</strong>{`. Standby `}<strong parentName="li">{`face right`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Up 2 Right, Blazing Wall. (Should be 1 down 1 right of Kyril).`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 2 Up 3 Right, Wind `}<strong parentName="li">{`Bead`}</strong>{` 1 Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Mount, go to 1 Up 1 Right of Kyril. Switch to Kika, Flame `}<strong parentName="li">{`Bead`}</strong>{` 2 Right between all soldiers.`}</li>
      <li parentName="ul"><strong parentName="li">{`Wendel`}</strong>{`: Switch to Millay, Mount. Go 2 right of Kyril. Kangacorn Spirit.`}</li>
      <li parentName="ul"><strong parentName="li">{`Gretchen`}</strong>{`: 1 Up 4 Forward, switch to Seneca. Rage Force 1 Right 3 Down, on bottom right soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Jeremy`}</strong>{`: 5 Right 1 Down, below Seneca. Switch to Corselia, Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Switch to Flare, 1 Up 4 Right to left of Seneca. Wind Bead 1 left of Trishtan.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Blazing Wall Finishes. Extra Move below Flare.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Blazing Wall finishes, `}<strong parentName="li">{`Face Left if Trishtan is in kill range.`}</strong></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Pay attention to where the bottom Officer is in the turn order! If he's after Flare, Have Kyril face up or down next turn.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-14"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Move between Kyril/Seneca/Millay/Kika, switch to Gary. Backup on self for all 5.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Move towards Archers, Falcon Thrust Archer ideally so Millay can back/side attack the other without losing movement. Extra move up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Move to side or back of Archer without wasting movement, Attack to kill. Extra move to right side of wooden ramp. `}<strong parentName="li">{`Face Down`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 3 Right 1 Down, Wind `}<strong parentName="li">{`Bead`}</strong>{` 1 Down. Face Down.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 1 Down 3 Right, Kill Archer by stairs. Extra Move 1 Left, next to Kyril.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Down 0-2 Right, Flaming Arrow whichever Mage you can kill, preferably the lower HP one. `}<em parentName="li">{`If there's only 1 alive, don't do it! Be mindful of Blazing Wall damage.`}</em>{` Extra Move behind Seneca.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: Switch to Mizuki. 2 Right, Flame Force Bead 3 Right (2 in front of Kyril). Extra Move 4 Up above wooden ramp.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: 1 Up 1 Right, Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Finish cast, Extra Move 1 Right 3 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Gary`}</strong>{`: Switch to Akaghi, 1 Right 3 Up. Water Force Bead 1 Right 3 Up. `}<em parentName="li">{`If Simeon did Wind of Sleep on Officer, place Flame Bead under him instead.`}</em></li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/b8b16c3839255cae6045828921fbdedc/6af66/HarunaSafeTiles.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADIElEQVQozxWRa1MbZRiG92epM5KEHPaQfXf3ffeUPSQbyGbTzSbk0G6htEBIQkgka0otmIC2Io1NQFpBqbQeitbaauuIOjojH5zxg//DZeaa59v13PczD1Z1a83uRr2z3nq33/Ler632ltvrC02v897H3c1hd/Net/+Jj9cfXszB/d72aK1/39sed7fG2OMfXh+fPhsfHh0cnxw++ea717/vfHq8dnOt2+t2VurtlUZruX6z3W41V3qd1XdWGu1Gq7d+27tzt783wqqVG6XibNGu2lb5klV2bDeZsjvNrWa56cqGK+dnM8K8RtuMNAOMMpfWdWW+1ijU1q8st7B0Kj9lFKZSBU3JyWIGskkfHuYkaItsRmRMERkyb+iiqUq2JuYSakZJOdPZywKfvpDTKUdXfXOahwYPkxSlIZanKCEYhAQpxqJ8KMSGw2w0wlIEihN8QkheylhpWccU2VSVrCBMsYwOSDnBIIpkjQSXMXNFp9jzOiUnT8a4ySBD4ihOChyQGSDnrfzlUgXjURJxGscqHJAklFDpWC4pXb+6uDUYLC3e0DUzGoGhAD0ZAHgUUgTvQ4ZpBFXHsjHESiJSOFq0M9OdhVLJrZruNW+wNVdruKXilG68+QYReJsOhxgihsKTwMk6p6MPV69UdDWNQUZkgcQBURA0ilUS+bJVr2cXl661G4Nb7avlmUAA+Ml4BFI4jE4y3mzln2f7+wu2raUwgZN8n6N5AKQIIVCMEkEpuzDzxWhjrloKToBYBEXDLInzOIH4t4K77szz8cbDRbOe1jBVUv3afnnEXAAoYSIMEacszVXNtBmnJBCXSRzGCchANUXSB233l5Phq/3bnp3BIM2xcQhIjsI5QPGQTfgmd3GIxNB+KQWyChmDhmF99fLPb3/87enPZ9//+tfXL14Nj77EtseHa7f6TqEyN1/z0bVpyCT8HH+FiFQBaTyXoGKMZRcenZ+dnf304o/z5+f/vfz7373Hp758dO/Bo40PPtp9cHx3/yhrFfxnhCZYAkd4lIlTiCI4CIR8vtgZbm5/NtrZezjYO9k9+Hzzzs7/3+lo26y8jYYAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Tiles safe from Mage",
            "title": "Tiles safe from Mage",
            "src": "/static/b8b16c3839255cae6045828921fbdedc/6af66/HarunaSafeTiles.png",
            "srcSet": ["/static/b8b16c3839255cae6045828921fbdedc/8ff5a/HarunaSafeTiles.png 240w", "/static/b8b16c3839255cae6045828921fbdedc/e85cb/HarunaSafeTiles.png 480w", "/static/b8b16c3839255cae6045828921fbdedc/6af66/HarunaSafeTiles.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <blockquote>
      <p parentName="blockquote">{`Tiles safe from Lightning Mage. Anything below Millay is safe as well.`}</p>
    </blockquote>
    <blockquote>
      <p parentName="blockquote">{`Watch the Archer in the back of the lower section. If he can reach Mizuki next turn, have Seneca Face Left.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-3-6"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 3 Right, Wind Bead 1 Right. `}<strong parentName="li">{`Face Up`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 1 Down 1 Right, Swallow to kill Officer. Extra Move 4 Right, `}<strong parentName="li">{`Face Up`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 4 Right, Rush Officer `}<strong parentName="li">{`from side`}</strong>{`. Extra Move 6 Left, tile left of Wooden Ramp.`}</li>
      <li parentName="ul"><em parentName="li">{`You rush from side so the Chest blocks your rush from going through the Officer.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Move to left side of wooden ramp.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 4 Right 1 Up, Flaming Arrow / Standby. `}<strong parentName="li">{`Face Up`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Mizuki`}</strong>{`: Move to Water Tiles on top side, just close enough to Earth Bead under 2 Soldiers. Extra Move as far away as possible.`}</li>
      <li parentName="ul"><strong parentName="li">{`Akaghi`}</strong>{`: Move to Fire Tile and chill.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Move to Water Tiles on top side, Flaming Arrow Soldier blocking Millay.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Go and kill Mage. Extra Move to safest tile. (Block tile Archer might use for Kika if possible)`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Kill other soldier on Earth Tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Cohort / Attack.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril / Andarc`}</strong>{`: Finish bottom side enemies. Flying Swallow Cut can be good here.`}</li>
    </ul>
    <p>{`From here just clean up.`}</p>
    <h4 {...{
      "id": "information-10"
    }}>{`Information`}</h4>
    <p>{`Chest is Ninja Garb`}<br parentName="p"></br>{`
`}{`S: Simeon's Spellbook (REALLY IMPORTANT)`}<br parentName="p"></br>{`
`}{`S Rank requires 17 minimum +tiles`}</p>
    <h3 {...{
      "id": "haruna-1"
    }}>{`Haruna`}</h3>
    <Menu mdxType="Menu">
      <p>{`Money needed: 6000 + 15000 + 12000 = 33000. Sell if short.`}</p>
      <h5 {...{
        "id": "outfitter-try-on-4"
      }}>{`Outfitter (Try on)`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Rage x3, Thunder x2, Flowing`}</li>
        <li parentName="ul">{`Millay: Cyclone x1/2, Mega Medicine, Godspeed Anklet`}</li>
        <li parentName="ul">{`Pablo: Rage, M. Earth`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith-5000-each"
      }}>{`Blacksmith (5000 each)`}</h5>
      <p>{`Sharpen Kyril, Kika, Millay`}</p>
      <h5 {...{
        "id": "rune-shop-3"
      }}>{`Rune Shop`}</h5>
      <ul>
        <li parentName="ul">{`Buy 4 Gale Orbs`}</li>
      </ul>
    </Menu>
    <p>{`Depart to Small Border Village`}</p>
    <h3 {...{
      "id": "small-border-village-fight"
    }}>{`Small Border Village (Fight)`}</h3>
    <h4 {...{
      "id": "strategy-15"
    }}>{`Strategy`}</h4>
    <PartyFormation formation={[{
      name: 'Seneca',
      x: 0,
      y: 1
    }, {
      name: 'Trishtan',
      x: 1,
      y: 2
    }, {
      name: 'Kyril',
      x: 2,
      y: 1
    }, {
      name: 'Ameria',
      x: 4,
      y: 3
    }]} mdxType="PartyFormation" />
    <h5 {...{
      "id": "beads-11"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Kyril: Thunder`}</li>
      <li parentName="ul">{`Pablo: Mother Earth`}</li>
      <li parentName="ul">{`Millay: Cyclone, Wind or Healing Item`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-16"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-15"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Seneca / Trishtan`}</strong>{`: Move all the way left, 1 down from cliff. Switch to Pablo. Mother Earth Bead 1 Right 3 Up so there's tiles under Cannon and there's a tile Fredrica will be able to stand on.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca / Trishtan`}</strong>{`: Move to Earth tile left near cannon, switch to Fredrica. Strong Shot to kill.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Thunder Force Bead 4 Up, Extra Move 2 Down 2 Left out of Cannon range.`}</li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Switch to Millay, Mount, 4 Right 2 Up, Rush Soldier by Wall. Extra Move 4 Up face down.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-15"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: Switch to Simeon, move to corner. Cast a LVL3 spell and cancel it.`}</li>
      <li parentName="ul"><em parentName="li">{`This is so he doesn't lap Pablo, which makes you unable to talk before you would finish fight.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Talk to Simeon, Standby rest of fight.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Standby`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 1 Up 1 Right, Rush Soldier from top. 5 Right 1 Up.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-7"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Move to left to block off Pablo and Simeon.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 9 Up (top right corner), `}<strong parentName="li">{`DISMOUNT`}</strong>{`. If after Kyril T3 and healthy can Standby, else Heal / Bead self.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-1"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Fly behind left cannon, `}<strong parentName="li">{`DISMOUNT`}</strong>{`, attack and hopefully kill (range).`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: Move to cover Pablo / Simeon, dismount. Chill rest of fight.`}</li>
      <li parentName="ul"><strong parentName="li">{`Selma`}</strong>{`: Move to cover Pablo / Simeon, Chill rest of fight.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Mount Red Owl, `}<strong parentName="li">{`8`}</strong>{` Up, Cyclone Force Bead 1 Up 1 Left (bottom right corner of cannon)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5"
    }}>{`Turn 5`}</h5>
    <p>{`Everyone but Millay does nothing from now on.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Dismount, 3 Up 1 Left (onto Wind Tile), Attack and kill Cannon. Extra Move 1 Right 2 Up, behind Chest. (This seems to prevent Cannon attack)`}</li>
    </ul>
    <h5 {...{
      "id": "turn-6"
    }}>{`Turn 6`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: `}<strong parentName="li">{`Mount`}</strong>{`, 1 Up 6 Left, Rush Cannon from top-left.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-7"
    }}>{`Turn 7`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Simeon`}</strong>{`: Talk to Pablo.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Rush final Cannon for Victory.`}</li>
    </ul>
    <h4 {...{
      "id": "information-11"
    }}>{`Information`}</h4>
    <p>{`S-Rank requires 28 +Tiles, not viable at all with this strat.`}<br parentName="p"></br>{`
`}{`Chest 1 is Silver Mail`}<br parentName="p"></br>{`
`}{`Chest 2 is Mother Earth Orb`}</p>
    <h3 {...{
      "id": "small-border-village-town"
    }}>{`Small Border Village (Town)`}</h3>
    <p>{`Enter Caravan`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Simeon: Simeon's Spellbook, Medals`}</li>
        <li parentName="ul">{`Equip Medals closest people in menu`}</li>
      </ul>
      <h5 {...{
        "id": "learn-skills-1"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Jewel, Paula: Godspeed, Extra Move`}</li>
        <li parentName="ul">{`Fredrica: Battle Lust - B, Bull's Eye - B, Extra Move, Godspeed`}</li>
        <li parentName="ul">{`Simeon: Fire Magic - B, Extra Move, Godspeed`}</li>
      </ul>
    </Menu>
    <p>{`Enter Small Border Village`}</p>
    <h3 {...{
      "id": "small-border-village-town-1"
    }}>{`Small Border Village (Town)`}</h3>
    <Menu mdxType="Menu">
      <p>{`Need $79000`}</p>
      <h5 {...{
        "id": "outfitter-sell-3"
      }}>{`Outfitter (Sell)`}</h5>
      <ul>
        <li parentName="ul">{`Andarc: Tome of the Black Arts`}</li>
        <li parentName="ul">{`Seneca: Corset, Strength Sash`}</li>
        <li parentName="ul">{`Paula, Jewel, Selma: Silver Mail, Silver Bracers`}</li>
        <li parentName="ul">{`Millay: Wing Mail, Medals`}</li>
        <li parentName="ul">{`Trishtan: Everything`}</li>
        <li parentName="ul">{`Medals`}</li>
      </ul>
      <h5 {...{
        "id": "outfitter-try-on---11200"
      }}>{`Outfitter (Try On) - $11200`}</h5>
      <ul>
        <li parentName="ul">{`Jewel: Rage x3`}</li>
        <li parentName="ul">{`Paula: Flowing`}</li>
        <li parentName="ul">{`Pablo: Rage Robe`}</li>
        <li parentName="ul">{`Fredrica: `}<strong parentName="li">{`Rage x2`}</strong>{`, M. Earth`}</li>
        <li parentName="ul">{`Millay: Mother Earth Armor, Rage, M. Earth x2, Flowing`}</li>
      </ul>
      <h5 {...{
        "id": "blacksmith---30000"
      }}>{`Blacksmith - $30000`}</h5>
      <p>{`Sharpen Kyril, Kika, Millay, Fredrica`}</p>
      <h5 {...{
        "id": "rune-shop---31800"
      }}>{`Rune Shop - $31800`}</h5>
      <ul>
        <li parentName="ul">{`Buy Wizard Orb`}</li>
        <li parentName="ul">{`Attach Fire to Simeon over Wind`}</li>
        <li parentName="ul">{`Attach Wizard to Corselia`}</li>
        <li parentName="ul">{`Attach Gale to Seneca, Jewel, Paula, Millay`}</li>
        <li parentName="ul">{`Attach Kangacorn to Paula`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "mido-shallows"
    }}>{`Mido Shallows`}</h3>
    <h4 {...{
      "id": "setup-14"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Corselia',
      x: 1,
      y: 0
    }, {
      name: 'Kyril',
      x: 0,
      y: 1
    }, {
      name: 'Seneca',
      x: 2,
      y: 1
    }, {
      name: 'Millay',
      x: 1,
      y: 2
    }, {
      name: 'Paula (K)',
      x: 3,
      y: 2
    }, {
      name: 'Trishtan (WO)',
      x: 0,
      y: 3
    }, {
      name: 'Fredrica (RO)',
      x: 2,
      y: 3
    }, {
      name: 'Jewel',
      x: 4,
      y: 3
    }]} mdxType="PartyFormation" />
    <p>{`Fast 1&2 positions can be swapped.`}</p>
    <h4 {...{
      "id": "strategy-17"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-16"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 6 Forward 1 Right`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Standard Simeon`}</li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: 7 Forward 1 Left, Rage Force Bead 3 Right on front soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: Move behind Simeon, Switch to Pablo. Fierce Wind Fangs the 4 soldiers. `}<strong parentName="li">{`Face Right`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Switch to Ameria. 2 Right 4 Up (1 below center Fire Tile).`}</li>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Mount White Owl, 8 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Forward Max, Explosion. Extra move 5 forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 3 Up 3 Right, Cyclone Sword on Ameria.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-16"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`DO NOT PASS LINE FOR ENEMY AGGRO TRIGGER. AKA DO NOT PASS Millay/Coselia + 1`}</strong>{`.`}</li>
      <li parentName="ul"><em parentName="li">{`Archer vs No Archer kill plays mostly the same. Difference is Fire Mage gets to live an extra turn.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Mount Kangacorn.`}<ul parentName="li">
          <li parentName="ul">{`If Archer lived, Rush him from direction that would let you get to 2 right of Corselia (usually left). Then extra move there. Face Up.`}</li>
          <li parentName="ul">{`If not, then move to 2 Right of Corselia, Mother Earth Bead self. Face Up.`}</li>
        </ul></li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`:`}<ul parentName="li">
          <li parentName="ul">{`If Archer lived Explosion, move behind Millay and Mother Earth Bead Millay. Face Right.`}</li>
          <li parentName="ul">{`If Archer died to Explosion, kill Fire Mage and move behind Millay. Face Right.`}</li>
        </ul></li>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Move to left of Millay, `}<strong parentName="li">{`Dismount`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Mount Owl, 1 Left 8 Up. Switch to Kika and kill soldier in front of Millay with Falcon Thrust.`}</li>
      <li parentName="ul"><strong parentName="li">{`Simeon`}</strong>{`: Move 3 Forward. Breath Of Ice Officer + 1/2 enemies. Extra Move 3 Right 1 Up, by wall aligned with Fredrica. This doesn't need to be precise.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Kill Water Mage, should be from side with Swallow on Wind Tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Standby rest of fight.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-8"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Rush Water Mage in the back from the front. Extra move 1 more Forward, face back.`}</li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: Kill someone with Strong Shot, probably mage. Move back towards front (tile in front of Millay) in case someone misses damage range.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Forward Max, Explosion Captain and Archer.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Kill something if possible, else move towards enemies.`}</li>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 5 Left 1 Up (right of Corselia). Switch to Andarc/Flare and Lightning Bead/Force between 2 back Water Soldiers. `}</li>
      <li parentName="ul"><strong parentName="li">{`Simeon`}</strong>{`: Flaming Arrow Lightning Soldier on Lightning Tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: 1 Up 5 Right, Falcon Thrust Lightning Soldier on Water Tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Go for mages if any alive.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-2"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Finish what should be last unit.`}</li>
      <li parentName="ul">{`If any left cleanup, be mindful of Martin's unit and important unit's position.`}</li>
    </ul>
    <h4 {...{
      "id": "information-12"
    }}>{`Information`}</h4>
    <p>{`Both spawns are based off unit kills.`}</p>
    <h3 {...{
      "id": "mido-plains-martin-duel"
    }}>{`Mido Plains (Martin Duel)`}</h3>
    <h4 {...{
      "id": "martin-lvl3-strat"
    }}>{`Martin LVL3 strat:`}</h4>
    <ol>
      <li parentName="ol">{`2 Back, Swallow, 4 Back`}</li>
      <li parentName="ol">{`Swallow, 2 Back 3 Right`}</li>
      <li parentName="ol">{`Swallow, 2 Right 3 Up`}</li>
      <li parentName="ol">{`1 Down 2 Left, Swallow. 3 Down towards wall.`}</li>
      <li parentName="ol">{`Swallow`}</li>
    </ol>
    <h5 {...{
      "id": "no-lvl3"
    }}>{`No LVL3`}</h5>
    <ul>
      <li parentName="ul">{`If you will level up off a Swallow hit. T1 move up left, Swallow, move to wall. Face away from wall. Next turn finish with Swallow / back attack.`}</li>
      <li parentName="ul">{`If you won't level, move to wall so he can reach you from 2 side. Wind Force to your side that he can't reach, and face towards side with no Wind Tiles. He should attack you next to Wind Tile, and you attack him next turn from that Wind Tile. Accuracy is an issue.`}</li>
    </ul>
    <h2 {...{
      "id": "the-imperial-city-of-graska"
    }}>{`The Imperial City of Graska`}</h2>
    <h3 {...{
      "id": "world-map-4"
    }}>{`World Map`}</h3>
    <p>{`Move to Graska.`}</p>
    <h4 {...{
      "id": "setup-15"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Jewel (RO)',
      x: 0,
      y: 0
    }, {
      name: 'Paula (WO)',
      x: 1,
      y: 0
    }, {
      name: 'Seneca',
      x: 0,
      y: 2
    }, {
      name: 'Fredrica',
      x: 1,
      y: 2
    }]} mdxType="PartyFormation" />
    <h4 {...{
      "id": "beads-12"
    }}>{`Beads`}</h4>
    <ul>
      <li parentName="ul">{`Kyril: Rage x2`}</li>
      <li parentName="ul">{`Jewel: Rage x3`}</li>
      <li parentName="ul">{`Paula: Flowing`}</li>
      <li parentName="ul">{`Pablo: Rage`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-18"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-17"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: Rage Bead 1 Down 1 Right. Extra move 9 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: Switch to Simeon. Move 1 Right, Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Flowing Bead 1 Right. Extra Move 9 Up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: Switch to Pablo. 1 Down 1 Right, Rage Bead 4 Left.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Blazing Wall. Extra Move to up to Gate.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 3 Up, Rage Bead 3 Up (Under Mages). `}<em parentName="li">{`If they're already on Fire Tiles, can go to bottom group and place Rage Bead there instead.`}</em></li>
    </ul>
    <h5 {...{
      "id": "turn-2-17"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Owls`}</strong>{`: 9 Forward`}</li>
      <li parentName="ul"><strong parentName="li">{`Simeon & Corselia`}</strong>{`: Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Standby rest of fight.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Rage Bead under Soldiers & allies if possible. If possible can move onto Fire tile too, has no job rest of fight.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-9"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: 9 Forward.`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: 9 Forward, Dismount.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-3"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: 5 Right 4 Forward, lined up with center shield. Rage Bead 3 up, 2 below fish.`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Mount Kangacorn, 8 Forward 2 Right. Switch to Kika, Rage Force 3 Up (1 Up 1 Left of fish).`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: 5 Forward 1 Up (between 2 right fish). Rage Bead 3 Up (2 above right fish). Extra Move 3 Right.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Chance that Roget gets Shredding off here, depends on turn order. Fine regardless.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-5-1"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Jewel or Kika`}</strong>{`: Switch to Millay, Mount Kangacorn, Rush Roget from right side.`}</li>
      <li parentName="ul"><strong parentName="li">{`Simeon & Corselia`}</strong>{`: Blazing Wall after spawns.`}</li>
    </ul>
    <h4 {...{
      "id": "information-13"
    }}>{`Information`}</h4>
    <p>{`Even if you kill the 3 fish and Roget at the same time, the rest will still spawn.`}</p>
    <h4 {...{
      "id": "notes-1"
    }}>{`Notes`}</h4>
    <p>{`Moving Millay/Paula/whoever out of Shredding range doesn't work, he Cyclone Forces the fish instead.`}</p>
    <h3 {...{
      "id": "caravan-8"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills-2"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Ornela: Bull's Eye - B, Extra Move, Godspeed`}</li>
        <li parentName="ul">{`Busk: Godspeed`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "graska"
    }}>{`Graska`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "outfitter-try-on---8900"
      }}>{`Outfitter (Try on) - $8900`}</h5>
      <ul>
        <li parentName="ul">{`Ornela: Strength Sash, M. Earth x2`}</li>
        <li parentName="ul">{`Paula: Godspeed Anklet`}</li>
        <li parentName="ul"><em parentName="li">{`Tomes for Simeon and Pablo for safety`}</em></li>
      </ul>
      <h5 {...{
        "id": "blacksmith---33000"
      }}>{`Blacksmith - $33000`}</h5>
      <ul>
        <li parentName="ul">{`Sharpen Kyril, Ornela, Millay, `}<strong parentName="li">{`Fredrica`}</strong></li>
      </ul>
      <h5 {...{
        "id": "rune-shop---600"
      }}>{`Rune Shop - $600`}</h5>
      <ul>
        <li parentName="ul">{`Millay: Giant Owl over Gale`}</li>
        <li parentName="ul">{`Ornela: Gale, Kangacorn`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "blood-stained-palace"
    }}>{`Blood Stained Palace`}</h3>
    <h4 {...{
      "id": "setup-16"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Millay (K)',
      x: 0,
      y: 0
    }, {
      name: 'Kyril',
      x: 1,
      y: 0
    }, {
      name: 'Ornela (KA)',
      x: 2,
      y: 0
    }, {
      name: 'Jewel (RO)',
      x: 1,
      y: 1
    }, {
      name: 'Ameria',
      x: 2,
      y: 1
    }]} mdxType="PartyFormation" />
    <p>{`Jewel or Paula are fine here, work exactly the same.`}</p>
    <p>{`With current setup can use Fredrica w/ Owl, Seneca, and Andarc to kill cannons.`}</p>
    <h4 {...{
      "id": "strategy-19"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-18"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 6 Up 1 Left, Rush Blue Spearman. Extra move 1 Left 2 Up, face right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: 6 Up 1 Right, Rush Blue Spearman. Extra move 1 Up 1 Right face left.`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: 9 Up (behind Red Swordsman), switch to Simeon. Silent Lake 1 Up 3 Left - Top left corner should be on top left staff wielder. Should hit fish and all staff wielders, and put Simeon on water. Face `}<strong parentName="li">{`back`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Forward max, Thunder Force Bead under Eye Fish. Leave water tiles available for Corselia on the side of Ameria (4 up should always be fine).`}</li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Mount Owl, 9 Forward onto water tile. Switch to Corselia. Explosion Eye Fish. Try to kill only Eye Fish, killing only 5 units prevents extra eye spawns later.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-18"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Rush Blue Fish in back from front. Get closer to cannons.`}</li>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: Move up, Rush someone (not mage, not enough EXP gained) further along the way if in the way. Should level up. Use extra move to move up.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-10"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul">{`Ornela / Millay: move up, swap to Seneca / Fredrica / Andarc and kill eyes.`}</li>
      <li parentName="ul">{`If you need more distance, Fredrica swap into Owl Mount is good.`}</li>
    </ul>
    <h4 {...{
      "id": "information-14"
    }}>{`Information`}</h4>
    <p>{`Chest is Chaos Shield`}<br parentName="p"></br>{`
`}{`S: Imperial Ring`}</p>
    <h2 {...{
      "id": "a-parting-of-ways"
    }}>{`A Parting of Ways`}</h2>
    <h3 {...{
      "id": "caravan-9"
    }}>{`Caravan`}</h3>
    <p>{`Enter Graska.`}</p>
    <h3 {...{
      "id": "graska-2"
    }}>{`Graska 2`}</h3>
    <h4 {...{
      "id": "info"
    }}>{`Info`}</h4>
    <p>{`Speed is finicky, you want Millay and/or Fredrica to go between Blazing Wall and back groups's 2nd turn, so they can place Rage Beads.`}</p>
    <h4 {...{
      "id": "setup-17"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Ornela (KA)',
      x: 0,
      y: 0
    }, {
      name: 'Ameria',
      x: 1,
      y: 0
    }, {
      name: 'Paula',
      x: 2,
      y: 0
    }, {
      name: 'Millay (K)',
      x: 0,
      y: 1
    }, {
      name: 'Busk (RO)',
      x: 1,
      y: 1
    }, {
      name: 'Fredrica (WO)',
      x: 2,
      y: 1
    }, {
      name: 'Jewel',
      x: 3,
      y: 1
    }, {
      name: 'Kyril',
      x: 4,
      y: 1
    }]} mdxType="PartyFormation" />
    <h4 {...{
      "id": "beads-13"
    }}>{`Beads`}</h4>
    <ul>
      <li parentName="ul">{`Millay: Mother Earth, Rage`}</li>
      <li parentName="ul">{`Fredrica: Rage`}</li>
      <li parentName="ul">{`Ornela: Flame`}</li>
      <li parentName="ul">{`Kyril: Rage`}</li>
    </ul>
    <h4 {...{
      "id": "info-1"
    }}>{`Info`}</h4>
    <ul>
      <li parentName="ul">{`Ameria needs Godspeed. Role can be played by any character with 7 movement that can ride a Kangacorn and is slower than all enemies.`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-20"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-19"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: 9 Forward, Flame Bead under middle Red Soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 10 Forward, `}<strong parentName="li">{`DISMOUNT`}</strong>{`. Mother Earth Bead under bottom left Blue Soldier, `}<strong parentName="li">{`FACE RIGHT`}</strong>{`.`}</li>
      <li parentName="ul"><em parentName="li">{`Millay has to move to this tile to manipulate Owl enemies to move towards you.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: 2 Left 6 Forward, Dismount. Strong Arm front Soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Busk`}</strong>{`: Move behind Ornela, switch to Lino. Unicorn lvl2 3 Red Soldiers.`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel/Paula`}</strong>{`: Move adjacent to Ornela, switch to Simeon. Silent Lake middle Blue Soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula/Paula`}</strong>{`: Move behind Simeon, switch to Pablo. Co-op `}<strong parentName="li">{`Bottom Left`}</strong>{` Soldier. `}<strong parentName="li">{`FACE BACK`}</strong>{`.`}</li>
      <li parentName="ul"><em parentName="li">{`Pablo face back manipulates Archer to target him, avoids crit chance on Millay. It's okay if he dies.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 2 Left 4 Up. Rage Force Bead on bottom middle of circle (4 Up).`}</li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Mount Kangacorn. 10 Forward, in front of Simeon. Switch to Corselia, Explosion 4 Forward, hit everyone but Archer.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-19"
    }}>{`Turn 2`}</h5>
    <p>{` `}<strong parentName="p">{`No important character should end up on a Fire Tile`}</strong>{`.`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: Rush Archer from back, move in front of Millay.`}</li>
      <li parentName="ul"><em parentName="li">{`If there was a survivor kill instead, as long as you can get to right tile.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: 3 Right 7 Down. Rage Bead under furthest Archer/s.`}</li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: Mount `}<strong parentName="li">{`RED OWL`}</strong>{`. 4 Left 4 Down.`}</li>
      <li parentName="ul"><strong parentName="li">{`Lino`}</strong>{`: Move in front of Ornela, Rage Bead under Archers. `}<em parentName="li">{`If you need to go further, mount Owl and switch to Seneca. She'll die to Blazing Wall. Don't want anyone too close to back group for AI reasons.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Simeon`}</strong>{`: Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Move off fire tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Swallow Ogre Breath Chest (Left chest)`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Start casting Blazing Wall`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-11"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: Kill a survivor if any.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Kill an archer or Rage Force Bead.`}</li>
      <li parentName="ul"><strong parentName="li">{`Fredrica`}</strong>{`: Rage Force Bead under 4 left enemies.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Cast Blazing Wall, should hopefully end fight.`}</li>
    </ul>
    <h4 {...{
      "id": "information-15"
    }}>{`Information.`}</h4>
    <p>{`S: Gate of Graska`}<br parentName="p"></br>{`
`}{`Left Chest: Ogre Breath`}<br parentName="p"></br>{`
`}{`Right Chest: Guardian Vestment`}<br parentName="p"></br>{`
`}{`8 Kills to spawn first extra group. All bowmen, middle 2 water side 2 earth.`}<br parentName="p"></br>{`
`}{`2 more kills spawn next 4. Middle column 2 water, sides 2 lightning. Front guy Swordsman, rest mages.`}</p>
    <h4 {...{
      "id": "notes-2"
    }}>{`Notes`}</h4>
    <p>{`You can have Fredrica go 8 Forward T1 for the Strong Shot, this will let you skip the weapon sharpen. However, the red owl rider might move directly up instead ruining the Explosion.`}</p>
    <h2 {...{
      "id": "a-warriors-reckoning"
    }}>{`A Warrior's Reckoning`}</h2>
    <h3 {...{
      "id": "caravan-10"
    }}>{`Caravan`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Kyril: Recommended Equipment (Ogre Breath)`}</li>
      </ul>
    </Menu>
    <p>{`Depart > Secret Facility`}</p>
    <h3 {...{
      "id": "iskas"
    }}>{`Iskas`}</h3>
    <h4 {...{
      "id": "setup-18"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Kyril',
      x: 0,
      y: 0
    }, {
      name: 'Ameria',
      x: 0,
      y: 1
    }, {
      name: 'Ornela (RO)',
      x: 4,
      y: 0
    }, {
      name: 'Jewel',
      x: 4,
      y: 1
    }]} mdxType="PartyFormation" />
    <h5 {...{
      "id": "beads-14"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Ornela: Mother Earth`}</li>
      <li parentName="ul">{`Kyril: Flowing`}</li>
    </ul>
    <h4 {...{
      "id": "strategy-21"
    }}>{`Strategy`}</h4>
    <p>{`General strategy is fast people rush bottom, Kyril hides in corner & Corselia kills enemies to protect Kyril.`}<br parentName="p"></br>{`
`}{`Can kill up to 7 enemies. When you kill 8 enemies more spawn.`}</p>
    <h5 {...{
      "id": "turn-1-20"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: 8 Down.`}</li>
      <li parentName="ul"><strong parentName="li">{`Jewel`}</strong>{`: Mount White Owl, 10 Down. Switch to Paula. `}<em parentName="li">{`If already on Owl, dismount before switch. Used to slow her down.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Ameria`}</strong>{`: Switch to Corselia, move 5 Right or 1 Down 4 Right, Breath of Ice or Explosion. Make sure you kill Wind Mage on bottom part. Extra move back to furthest Water tile.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Flowing Force Bead 1 Down 3 Right. Move into bottom corner.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-2-20"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: 2 Down 4 Right (out of range of cannon.)`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Mount `}<strong parentName="li">{`Armored`}</strong>{` Kangacorn, Rush chest. Forward max. `}<em parentName="li">{`Normal Kangacorn should work fine too`}</em>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Try to kill someone, preferably with Cyclone Sword.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Kill something with Flaming Arrows`}</li>
      <li parentName="ul">{`Kyril and Corselia just kill stuff and hide from now on. Kyril can Swallow LVL3 people.`}</li>
      <li parentName="ul">{`Normal Kangacorn should be fine, I tested with 60SPD Jewel & 57SPD Ornela and it still worked out. Might be more based on Millay's speed.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-12"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: Forward max.`}</li>
      <li parentName="ul"><strong parentName="li">{`Paula`}</strong>{`: Switch to Millay. Mount White Owl. 1 Down 8 Right, Owl Heart. `}<strong parentName="li">{`Make sure you move first before Owl Heart!`}</strong></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Iskas should move 4 left with these positions, even if there's an Earth Tile there.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-4-4"
    }}>{`Turn 4`}</h5>
    <blockquote>
      <p parentName="blockquote">{`Ornela needs to be before Iskas. Millay needs to be after Iskas. Iskas should Flaming Arrow Ornela unless Cannon shenaningans, then he casts Berserk Blow.`}</p>
    </blockquote>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Ornela`}</strong>{`: 5 Up, Mother Earth Bead 3 Right 1 Up so 1 tile under Iskas. Extra Move 3 Left. `}<em parentName="li">{`(1 down 1 left from cannon.)`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Move behind Iskas and attack to kill. Shouldn't even need to Dismount.`}</li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`If Millay misses, or if you run into issues because of the Rune Cannon, you can Extra Move Millay out of the way`}<br parentName="p"></br>{`
`}{`and have Ornela attack from behind too. If the cannon places Lightning Tiles under Iskas, probably better for Millay to switch to Pablo and place a Earth Tile under Iskas, and have Ornela attack him from behind on a Lightning tile.`}</p>
    </blockquote>
    <h4 {...{
      "id": "information-16"
    }}>{`Information`}</h4>
    <p>{`Iskas doesn't want to attack people that are on midair tiles.`}<br parentName="p"></br>{`
`}{`Every point of SKL = 1% more accuracy vs Iskas (and probably in general).`}<br parentName="p"></br>{`
`}{`Bottom Right Chest Guardian Vestment`}<br parentName="p"></br>{`
`}{`Left Chest Hero's Armor`}<br parentName="p"></br>{`
`}{`More units spawn after killing 8 units`}<br parentName="p"></br>{`
`}{`Iskas is Lightning Element`}<br parentName="p"></br>{`
`}{`Units keep Spawning 1 by one even after second phase`}<br parentName="p"></br>{`
`}{`Rune Cannons inflict random statuses`}</p>
    <h3 {...{
      "id": "fishskas"
    }}>{`Fishskas`}</h3>
    <h4 {...{
      "id": "setup-19"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Millay (K)',
      x: 2,
      y: 1
    }, {
      name: 'Fredrica',
      x: 2,
      y: 2
    }, {
      name: 'Ornela (RO)',
      x: 2,
      y: 3
    }]} mdxType="PartyFormation" />
    <p><strong parentName="p">{`REMOVE CORSELIA FROM FORMATION`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Order supposed to be Ornela > (Fishskas or Millay) > Fredrica > Eye`}</p>
    <h5 {...{
      "id": "strategy-22"
    }}>{`Strategy`}</h5>
    <ul>
      <li parentName="ul">{`Ornela: 7 Right, Mother Earth Bead 4 Right under Fishskas.`}</li>
      <li parentName="ul">{`Millay: 7 Right 2 Up. Flowing Force 1 Down 1 Right.`}</li>
      <li parentName="ul">{`Fredrica: 8 Right behind Red Fish, Switch to Corselia. Flaming Arrow Fishskas.`}</li>
    </ul>
    <h3 {...{
      "id": "evil-eye"
    }}>{`Evil Eye`}</h3>
    <h5 {...{
      "id": "information-17"
    }}>{`Information`}</h5>
    <ul>
      <li parentName="ul">{`Evil Eye has 2 damage gates, at 33% & 66%. After each one it will back away and start charging. First unlocks it's column attack. After 2nd charge it does the big nuke.`}</li>
      <li parentName="ul">{`It does physical damage with its bunch of beams attack.`}</li>
    </ul>
    <h5 {...{
      "id": "strategy-23"
    }}>{`Strategy`}</h5>
    <ol>
      <li parentName="ol">{`1 Forward, Cyclone Force 4 Forward`}</li>
      <li parentName="ol">{`3 Forward, Swallow LVL3. Extra move 1 more forward, to center Wind tile. Eye should move away now.`}</li>
      <li parentName="ol">{`Standby, face towards it. If under 500 damage, move 1 tile towards it, Swallow LVL1, and move back to center.`}</li>
      <li parentName="ol">{`Move behind it, Swallow LVL3 for kill.`}</li>
    </ol>
    <p>{`After Mirror breaking cutscene `}<strong parentName="p">{`DONT MASH TRIANGLE`}</strong>{`. Kyril gets stuck until you stop mashing.`}<br parentName="p"></br>{`
`}{`Final Textbox is Corselia ""Kyril... Kyril!!"`}</p>
    <h2 {...{
      "id": "general-information"
    }}>{`General Information`}</h2>
    <h4 {...{
      "id": "counterattack"
    }}>{`Counterattack`}</h4>
    <p>{`Can counter when hit`}<br parentName="p"></br>{`
`}{`Probability reduced by enemy Bull's Eye.`}<br parentName="p"></br>{`
`}{`25%/50% penalty to counter attack & avoidance when hit from side/back.`}<br parentName="p"></br>{`
`}{`Can reduce penalty with Mind's Eye.`}</p>
    <h4 {...{
      "id": "mounts"
    }}>{`Mounts`}</h4>
    <p>{`Kangacorns: +3 MOV, JMP = 1`}<br parentName="p"></br>{`
`}{`Normal kangacorn: +50% STR, +10% SPD... -30% EVA`}<br parentName="p"></br>{`
`}{`Armored Kangacorn: +50% STR, +30% PDF... -30% EVA`}<br parentName="p"></br>{`
`}{`Useable by 1h sword, spear and missile weapon users.`}</p>
    <p>{`Owls: +2 MOV, JMP = 4 (dunno if that has any effect for the owls)`}<br parentName="p"></br>{`
`}{`Red/Blue Giant Owl: +30% STR, +30% EVA, +30% SPD... -30% PDF`}<br parentName="p"></br>{`
`}{`White Giant Owl (Armored): +30% STR, +30% EVA... -10% PDF`}<br parentName="p"></br>{`
`}{`Useable by 1h sword, spear, and most archers (not Seneca). Archers have their range increased by 1 while on an owl.`}</p>
    <h4 {...{
      "id": "coops"
    }}>{`Coops`}</h4>
    <p>{`kfcrispy: i don't know the coop damage formula, but they definitely don't use Battle Lust. perhaps they use raw stats (affected by terrain) and the base power like a spell`}</p>
    <p>{`Can maybe test via editing stats.`}<br parentName="p"></br>{`
`}{`+ATK (Seared Bonito) doesn't increase damage`}<br parentName="p"></br>{`
`}{`Enemy Tile very slightly affects damage? (Went from 123 to 130 in test, going from positive to neutral)`}<br parentName="p"></br>{`
`}{`Positive tile for allies slightly affects damage (Neutral tile Kyril 123, pos tile Kyril 133)`}</p>
    <h4 {...{
      "id": "items"
    }}>{`Items`}</h4>
    <p>{`Puffered Fish Sashimi doesn't raise M.ATK?`}</p>
    <h4 {...{
      "id": "firefly"
    }}>{`Firefly`}</h4>
    <p>{`If Enemies can't hit Eugene normally, but can hurt him by placing tiles they will place tiles.`}</p>
    <h4 {...{
      "id": "status"
    }}>{`Status`}</h4>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Unfriendly`}</strong>{`: Also stops recharging of Co-ops.`}</li>
      <li parentName="ul"><strong parentName="li">{`Accuracy +`}</strong>{`: Increases accuracy by 10%`}</li>
    </ul>
    <h4 {...{
      "id": "ranking"
    }}>{`Ranking`}</h4>
    <p><a parentName="p" {...{
        "href": "http://suikosource.com/phpBB3/viewtopic.php?f=40&t=5022&sid=6a16db4f67d1fabdf82b6b494eeb3511&start=45#p155223"
      }}>{`http://suikosource.com/phpBB3/viewtopic.php?f=40&t=5022&sid=6a16db4f67d1fabdf82b6b494eeb3511&start=45#p155223`}</a></p>
    <h5 {...{
      "id": "criteria-explanation"
    }}>{`Criteria explanation`}</h5>
    <p>{`Turn amount: number of actions made regardless of foe or friend (!!!)`}<br parentName="p"></br>{`
`}{`Total damage: The total damage all allies (excluding NPCs) received`}<br parentName="p"></br>{`
`}{`Damage rate: The average damage dealt to enemies from attacks (including runes)`}<br parentName="p"></br>{`
`}{`Positive element count: The number of times your allies (excluding NPCs) end a turn on positive element`}<br parentName="p"></br>{`
`}{`Total value of received experience: self-explaining`}</p>
    <h5 {...{
      "id": "numeric-values-to-determine-the-rank"
    }}>{`Numeric values to determine the rank`}</h5>
    <p>{`STEP1 Determining the rank for each criteria`}<br parentName="p"></br>{`
`}{`• Turn amount & total damage`}<br parentName="p"></br>{`
`}{`S: base value +0%`}<br parentName="p"></br>{`
`}{`A: base value +30%`}<br parentName="p"></br>{`
`}{`B: base value +80%`}<br parentName="p"></br>{`
`}{`C: above`}<br parentName="p"></br>{`
`}{`• Damage rate & positive element count & total experience value`}<br parentName="p"></br>{`
`}{`S: base value -0%`}<br parentName="p"></br>{`
`}{`A: base value -30%`}<br parentName="p"></br>{`
`}{`B: base value -80%`}<br parentName="p"></br>{`
`}{`C: below`}</p>
    <ul>
      <li parentName="ul">{`Each stage has different base values (?) `}{`[Look at the sheet that KFCrispy shared some posts ago]`}</li>
      <li parentName="ul">{`[I don’t understand the first sentence]`}{` A missed attack is counted as an attack that did 0 damage`}</li>
      <li parentName="ul">{`[Not sure but it seems…]`}{` The base value for experience is 500 per enemy.`}<br parentName="li"></br>
        {`STEP2 For each of the 5 criteria you’ll get a score depending on the rank you achieved in each criteria`}<br parentName="li"></br>
        {`S: 0 A: 10 B: 30 C: 60`}<br parentName="li"></br>
        {`STEP3 These scores are used to calculate an average score that will finally determine the stage rank`}<br parentName="li"></br>
        {`S: less than 5 A: less than 13 B: less than 31 C: 31 or more`}<br parentName="li"></br>
        {`[-> it means you can A rank in 2 criteria as long as you S rank the remaining 3, because you would get 10+10+0+0+0=10 -> 20/5=4 -> S rank! If you B rank in any criteria there's no chance of getting stage rank S!]`}</li>
    </ul>
    <h4 {...{
      "id": "eugene-days"
    }}>{`Eugene days`}</h4>
    <p>{`Based off day in Obel.`}</p>
    <p>{`Water Day: Move to Illuya, then Na-Nal`}<br parentName="p"></br>{`
`}{`Wind Day: Na-Nal, Illuya, Na-Nal`}<br parentName="p"></br>{`
`}{`Lightning: Na-Nal, Nay, Na-Nal`}<br parentName="p"></br>{`
`}{`Fire: Illuya, Na-Nal, Nay, Na-Nal`}<br parentName="p"></br>{`
`}{`Earth: Na-Nal`}</p>
    <h4 {...{
      "id": "legacy-graska-2"
    }}>{`Legacy Graska 2`}</h4>
    <h4 {...{
      "id": "setup-20"
    }}>{`Setup`}</h4>
    <p>{`Backline formation doesn't matter except Kyril.`}<br parentName="p"></br>{`
`}{`Middle front should be slower of Jewel / Paula.`}<br parentName="p"></br>{`
`}{`Assuming Jewel is faster, adjust accordingly.`}<br parentName="p"></br>{`
`}{`Speedwise ideally it's Ornela, Fredrica/Millay, Jewel, Paula.`}<br parentName="p"></br>{`
`}{`Can adjust with mounts and/or Godspeed Anklets.`}<br parentName="p"></br>{`
`}{`Want Paula to be 39SPD or more.`}<br parentName="p"></br>{`
`}{`Ornela & Millay on Kangacorns.`}</p>
    <h5 {...{
      "id": "requirements"
    }}>{`Requirements`}</h5>
    <p>{`Fredrica: Rage/Fire Bead`}<br parentName="p"></br>{`
`}{`Millay: Earth/Mother Earth Bead`}<br parentName="p"></br>{`
`}{`Ornela: Cyclone Force Bead`}</p>
    <p>{`Formation`}</p>
    <p>{`Busk Kyril Simeon -`}<br parentName="p"></br>{`
`}{`Millay Fredrica Paula Jewel Ornela`}</p>
    <h4 {...{
      "id": "strategy-24"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-21"
    }}>{`Turn 1`}</h5>
    <p>{`Ornela: 7D (Even with back Red Soldiers)b, Cyclone Force Bead. Ideally on front guy in second group, but if Earth/Fire already set tile in front of Ornela works. Important part is to get Wind tile infront of front Blue Spearman.`}<br parentName="p"></br>{`
`}{`Millay: 9D1R, Earth Force Bead middle spearman / Mother Earth Force tile below middle spearman.`}<br parentName="p"></br>{`
`}{`Fredrica: Mount if not mounted, move next to front red swordsman and Fire Tile middle / Rage tile front.`}<br parentName="p"></br>{`
`}{`Jewel: 8D1L, behind back red swordsman. Swap to Lino & Unicorn LVL2 2 Blue Spearman.`}<br parentName="p"></br>{`
`}{`Paula: 9D, swap to Seneca and Hawk LVL3. Should kill 6. Ideally front 8 are dead here.`}</p>
    <p>{`Simeon: move up and Breath of Ice Ogre Breath (Left Chest)`}<br parentName="p"></br>{`
`}{`Busk: move up`}<br parentName="p"></br>{`
`}{`Kyril: move down`}</p>
    <h5 {...{
      "id": "turn-2-21"
    }}>{`Turn 2`}</h5>
    <p>{`Simeon: Flowing Force Bead center column, 3 north of chest. Can move cursor to chest, move left to middle, then up 3.`}<br parentName="p"></br>{`
`}{`Busk: move up (not into water).`}<br parentName="p"></br>{`
`}{`Fredrica: move down, swap to Kika and kill something.`}<br parentName="p"></br>{`
`}{`Rest: keep moving down and killing stuff. Be careful with Millay. Unit deaths don't matter but permadeath does.`}</p>
    <h5 {...{
      "id": "turn-3--on-2"
    }}>{`Turn 3 & on.`}</h5>
    <p>{`Simeon move into front water tile.`}<br parentName="p"></br>{`
`}{`When top soldiers spawn Breath of Ice middle 2. Busk gets on owl and kills right one.`}<br parentName="p"></br>{`
`}{`Rest keep doing same thing.`}</p>
    <h3 {...{
      "id": "haruna-previous"
    }}>{`Haruna Previous`}</h3>
    <h4 {...{
      "id": "setup-21"
    }}>{`Setup`}</h4>
    <PartyFormation formation={[{
      name: 'Trishtan (K)',
      x: 1,
      y: 0
    }, {
      name: 'Kyril',
      x: 1,
      y: 1
    }, {
      name: 'Gretchen',
      x: 1,
      y: 2
    }, {
      name: 'Andarc',
      x: 1,
      y: 3
    }, {
      name: 'Eugene',
      x: 0,
      y: 0
    }, {
      name: 'Ameria',
      x: 0,
      y: 1
    }, {
      name: 'Jeremy',
      x: 0,
      y: 2
    }, {
      name: 'Pablo',
      x: 0,
      y: 3
    }]} mdxType="PartyFormation" />
    <p>{`Note: Pablo is assumed to be slowest character here, doesn't have to be Pablo but you need someone slower than everyone else here.`}<br parentName="p"></br>{`
`}{`Most slots are interchangable as well. Only important ones should be Kyril & Trishtan. The 4 Kangacorn riders are interchangable.`}</p>
    <h5 {...{
      "id": "beads-15"
    }}>{`Beads`}</h5>
    <ul>
      <li parentName="ul">{`Seneca: Wind x2`}</li>
      <li parentName="ul">{`Kika: Wind x2`}</li>
      <li parentName="ul">{`Flare: Flame, (Cyclone Sword)`}</li>
    </ul>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px",
          "width": "100%"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": ["noopener"]
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "70%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsSAAALEgHS3X78AAADC0lEQVQozw3QW3OaaACAYX7h7k1vdl3T1TSpkCgKiIJyBkFBPs4gaIxGjYdUG21SO02a6SltZ7s7k5mmM73qbX/G5u69e2ZeyHI64dGoezJLhtPucBb2jr1OkozH4+VqstwM56vh4vno2eZouhzMV73ZKp6cJZPldP1qtb2C3ny52378Z75+MTvfXNx8vPn67XT1fLRpG4Ek0HxDEBssrwiSzAmSpDXt6OJiAYBOV+otvQ1Fnjs+ihIfCPW6zNRVUaRQeNElWXGvVMxWyGyZfNKopAUsVeVQUqs73ZbFotJuyq8fQqClDhNv0A2ZarV0gKBwDtndrRP7fO1Q5mu+RgUyHlqapcuua7gBsBwAVMlVeY2lIdCUR/3kqONpkqiIoibLeD7PkSiBZGgCEQqPQeHPSKF9s+mZOtDkxLfNZoOvVVWRhRSBazcbtmmE3sM6r9/riCyHw9n9QqrYLB7kMwpfiQPDjcN26FMt3U06q+nA1SVPFyEbGL5reY7pO6CXRLapSwxN4sUnCIyWciUSLwsC7YWk7RHAqTiBYPv9bhzqCkfkIc8G0+l4PBp04yiOgnqFYCmyjGHpnexOsUyTxYDY4RWR5Jgax2gipz6gy4TptfkyAgWBPZufDgf9XhzGoWe0mkytVi7kcySCVff5x7+1c78rxD52kMGQTI2l/OPg7bs5mLQYrgrJEhv4bujbw363343ijk9VKoWnMEzBiHn4F5x2JSyWCKpWLTeUmqromvzt+sKuY2U0D1EU3tZboe9EgdsJ3Ch0gWkQKFZC86LJVzlS4BgFz0nYnshUCIbBFVmxRFKmSRKDCAzRVdmx2p5tarLYVOWHYCQGPnxayGbTjx5lUn+Ixb0TBb++/Xr1+f7m7sf52/eXt19G6y1kn66j0SKMwuF40hsMPN9xgaGBRg6Fd5C/8VxagVMuTw4S/+X3X//9e/vp7v7d/c/P338+u/oA8b1FZ7ldrDfn1+/PLl+bwGookufaAsPShorJouFaEUu4cSydXR9fvTx5sT1+9Wly+bp3uvgfhkfM85MEyREAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Turn 1 Setup",
            "title": "Turn 1 Setup",
            "src": "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png",
            "srcSet": ["/static/783a628dbb7f0af3379e07089c087362/8ff5a/HarunaT1Setup.png 240w", "/static/783a628dbb7f0af3379e07089c087362/e85cb/HarunaT1Setup.png 480w", "/static/783a628dbb7f0af3379e07089c087362/6af66/HarunaT1Setup.png 640w"],
            "sizes": "(max-width: 640px) 100vw, 640px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span></p>
    <h4 {...{
      "id": "strategy-25"
    }}>{`Strategy`}</h4>
    <h5 {...{
      "id": "turn-1-22"
    }}>{`Turn 1`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: 4 Right 4 Down, `}<strong parentName="li">{`DISMOUNT`}</strong>{`. Standby `}<strong parentName="li">{`face right`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Up 1 Right, Blazing Wall. (Should be 1 down 1 right of Kyril).`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 2 Up 3 Right, Wind Force 1 Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kangacorn 1`}</strong>{`: Mount, go to 1 up 1 right of Kyril. Switch to Kika, Flame Bead 2 Right between 3 soldiers.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kangacorn 2`}</strong>{`: Mount, go to 1 down 1 right of Kyril. Switch to Seneca, Rage Force 1 Right 3 Down, on bottom right soldier.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kangacorn 3`}</strong>{`: Mount, go 1 below Seneca. Switch to Corselia, Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kangacorn 4`}</strong>{`: Mount, 1 left of Seneca. Switch to Flare, Wind Force 1 left of Trishtan.`}</li>
      <li parentName="ul"><strong parentName="li">{`Pablo`}</strong>{`: Switch to Millay, Mount. Go 2 right of Kyril. Kangacorn Spirit.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: Blazing Wall Finishes. Extra Move below Flare.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Blazing Wall finishes, `}<strong parentName="li">{`Face Left if Trishtan is in kill range.`}</strong></li>
    </ul>
    <blockquote>
      <p parentName="blockquote">{`Pay attention to where the bottom Officer is in the turn order! If he's after Flare, Have Kyril face up or down next turn.`}</p>
    </blockquote>
    <h5 {...{
      "id": "turn-2-22"
    }}>{`Turn 2`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Trishtan`}</strong>{`: Move to left of Kika, switch to Gary. Backup center Wind Tile to buff 4 characters.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Move towards Archers, Falcon Thrust Archer that Millay can't rush for extra movement. Move back/left 1 tile with Extra Move.`}</li>
      <li parentName="ul"><em parentName="li">{`You move back here incase the Officer gets 2 turns in a row, keeps Kika out of range of him.`}</em></li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: 3 Right 2 Down, Flying Swallow down to kill Archer. Extra move 1 up. `}<strong parentName="li">{`If Flare is before Officer face up or down.`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 1 Down 2 Right, Wind Bead on self.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Move to Archer, Rush to kill. Move all the way up and as far right as you can (2 right of Wooden Board.) `}<strong parentName="li">{`Face down.`}</strong></li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 1 Down 0-2 Right, Flaming Arrow whichever Mage you can kill, preferably the lower HP one. `}<em parentName="li">{`If there's only 1 alive, don't do it! Be mindful of Blazing Wall damage.`}</em>{` Extra Move behind Seneca.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Blazing Wall.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: 2 Right, Flame Force Bead 3 Right (right of Officer).`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Finish cast, Blazing Wall 5 Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Gary`}</strong>{`: Move to Water Tile, switch to Ema and chill rest of fight.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-3-13"
    }}>{`Turn 3`}</h5>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Kika`}</strong>{`: Move 1 below right side of wooden ramp, Wind Bead 2 Right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Seneca`}</strong>{`: 4 Right 1 Up, Wind Bead 1 Right. Face right.`}</li>
      <li parentName="ul"><strong parentName="li">{`Millay`}</strong>{`: Rush Officer. Move to left side of wooden ramp.`}</li>
      <li parentName="ul"><strong parentName="li">{`Kyril`}</strong>{`: Swallow to kill Officer. Extra move 1 Down 5 Right. Face up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Andarc`}</strong>{`: 5 Right, Cohort / Flaming Arrow / Standby. Face up.`}</li>
      <li parentName="ul"><strong parentName="li">{`Corselia`}</strong>{`: Flaming Arrow someone.`}</li>
      <li parentName="ul"><strong parentName="li">{`Flare`}</strong>{`: Kill mage if survivors, else Standby on Water tile.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-4-5"
    }}>{`Turn 4`}</h5>
    <ul>
      <li parentName="ul">{`Top side changes depending on turn order. If Millay can reach the mage, go for the kill on the mage. If not, Kill 2 closest and Extra Move out of range. Kika its 5 back, Millay it's 1 up 1 left of Kika. Be mindful of archer getting double turn if killing mage. Also, Kika won't kill the Soldier without elemental advantage.`}</li>
      <li parentName="ul">{`Bottom half kills rest, chills.`}</li>
    </ul>
    <h5 {...{
      "id": "turn-5-2"
    }}>{`Turn 5`}</h5>
    <ul>
      <li parentName="ul">{`Top side finishes remaining 2 units.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      